<template>
  <div
    :style="darkmode ? darkModeStyles : {}"
    class="fillContent"
    ref="mapcontainer"
    @contextmenu.prevent="onContextMenu"
    tabindex="-1"
    @keydown.left="onKeyLeft"
    @keydown.right="onKeyRight"
  >
    <!-- <div class="absolute z-[1000] bg-white px-2 ml-2">Debug: {{currentFleetMapState.selectedMissionPlanMissionId }}</div>        -->
    <vl-map
      ref="map"
      :class="{ hover: cursorHover, infos: cursorHelp }"
      @pointermove="onPointerMove"
      @singleclick="onSingleclick"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      class="fillContent"
      @mounted="onMapMounted"
    >
      <vl-view ref="view" :center.sync="center" :zoom.sync="zoom"></vl-view>
      <!-- Calque Open Street Map (Stadia Maps) -->
      <vl-layer-tile :zIndex="1" v-if="mapstate.baseMapLayer.id == 'OSM'">
        <vl-source-xyz
          url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}.png"
          :attributions="[
            '&copy; <a href=\'https://stadiamaps.com/\'>Stadia Maps</a> &copy; <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap contributors</a>',
          ]"
          :tile-load-function="stadiaTileLoadFunction"
        ></vl-source-xyz>
      </vl-layer-tile>
      <!-- other layers from config -->
      <component
        v-if="!mapstate.layermapconfig[layer.id] || mapstate.layermapconfig[layer.id].canRender"
        :zIndex="mapstate.baseMapLayer.id == layer.id ? 1 : 2"
        :opacity="
          ((isInMissionLayer($store.myGetters.mapLayersDic[layer.id])
            ? (mapstate.missionLayermapOpacity == 0 ? 0 : mapstate.missionLayermapOpacity || 100) / 100.0
            : layer.id?.toString()?.startsWith('AIS_')
            ? (mapstate.layermapOpacity['AIS'] === 0 ? 0 : mapstate.layermapOpacity['AIS'] || 100) / 100.0
            : 1) *
            (mapstate.layermapOpacity[layer.id] === 0 ? 0 : mapstate.layermapOpacity[layer.id] || 100)) /
          100.0
        "
        v-for="layer in layermaps"
        :is="layer.cmp"
        :key="layer.id"
        v-bind="layer"
      >
        <!-- add vl-source-* -->
        <component :is="layer.source.cmp" v-bind="layer.source">
          <!-- add static features to vl-source-vector if provided -->
          <vl-feature
            v-if="layer.source?.staticFeatures?.length"
            v-for="feature in layer.source.staticFeatures"
            :key="feature.id"
            :id="feature.id"
            :properties="feature.properties"
          >
            <component :is="geometryTypeToCmpName(feature.geometry.type)" v-bind="feature.geometry"></component>
          </vl-feature>

          <!-- add inner source if provided (like vl-source-vector inside vl-source-cluster) -->
          <component v-if="layer.source.source" :is="layer.source.source.cmp" v-bind="layer.source.source">
            <!-- add static features to vl-source-vector if provided -->
            <vl-feature
              v-if="layer.source.source?.staticFeatures?.length"
              v-for="feature in layer.source.source.staticFeatures"
              :key="feature.id"
              :id="feature.id"
              :properties="feature.properties"
            >
              <component :is="geometryTypeToCmpName(feature.geometry.type)" v-bind="feature.geometry"></component>
            </vl-feature>
          </component>
        </component>
        <!--// vl-source-* -->

        <!-- add style components if provided -->
        <!-- create vl-style-box or vl-style-func -->
        <component v-if="layer.style" v-for="(style, i) in layer.style" :key="i" :is="style.cmp" v-bind="style">
          <!-- create inner style components: vl-style-circle, vl-style-icon, vl-style-fill, vl-style-stroke & etc -->
          <component v-if="style.styles" v-for="(st, cmp) in style.styles" :key="cmp" :is="cmp" v-bind="st">
            <!-- vl-style-fill, vl-style-stroke if provided -->
            <vl-style-fill v-if="st.fill" v-bind="st.fill"></vl-style-fill>
            <vl-style-stroke v-if="st.stroke" v-bind="st.stroke"></vl-style-stroke>
          </component>
        </component>
        <!--// style -->
      </component>
      <!--// other layers -->
      <vl-layer-vector v-if="mapReady" ref="vectorsLayer" :zIndex="100">
        <vl-source-vector>
          <template v-if="canShowMission(mission)" v-for="mission in visibleMission">
            <template v-if="mission.covId || missionAbsState(mission.misId).showPath">
              <!-- Points en multi point du chemin de la mission | 4 < zoom -->
              <vl-feature
                :properties="{
                  type: 'missionPoint',
                  missionid: mission.misId,
                  selected: infosMissionIds.some(id => mission.misId == id),
                }"
                v-if="zoom >= getBestZoom(mission)"
                :key="'P' + mission.misId"
              >
                <template slot-scope="feature">
                  <vl-geom-multi-point :coordinates="getPath(mission)"></vl-geom-multi-point>
                </template>
              </vl-feature>
              <!-- Points unitaire + num cycle du chemin de la mission sélectionnée -->
              <template
                v-if="
                  (missionDetailVisibility?.[mission.misId] || infosMissionIds.some(id => mission.misId == id)) &&
                  zoom >= getBestZoom(mission) /*&& rangeLength(mission) < 400*/
                "
              >
                <vl-feature
                  v-if="yo?.yoGpsLat && yo?.yoGpsLon && isInTimeLineRange(mission.misId, index)"
                  :properties="{
                    type: 'yo',
                    missionid: mission.misId,
                    index,
                    key: mission.misLibelle,
                    yo,
                    text: mapstate.showCycle ? yo.yosCycle : '',
                  }"
                  v-for="(yo, index) in mission.yoArray"
                  :key="'SP_' + mission.misId + '_' + yo.yosCycle"
                >
                  <template slot-scope="feature">
                    <vl-geom-point :coordinates="[yo.yoGpsLon, yo.yoGpsLat]"></vl-geom-point>
                  </template>
                </vl-feature>
              </template>
              <!-- lignes pointillés du chemin de la mission  | zoom > 4 -->
              <vl-feature
                :properties="{ type: 'missionline', missionid: mission.misId }"
                v-if="zoom >= getBestZoom(mission) && getPath(mission).length > 0"
                :key="'L' + mission.misId"
              >
                <template slot-scope="feature">
                  <vl-geom-line-string :coordinates="getPath(mission)"></vl-geom-line-string>
                </template>
              </vl-feature>
              <!-- fleches de courants de dérive vue par le glider sélectionné  -->
              <template
                v-if="
                  mapstate.showOceanCurrent &&
                  (missionDetailVisibility?.[mission.misId] || infosMissionIds.some(id => mission.misId == id)) &&
                  zoom >= getBestZoom(mission) /*&& rangeLength(mission) < 400*/
                "
              >
                <vl-feature
                  v-for="(yo, index) in mission.yoArray"
                  v-if="
                    index > 0 &&
                    !yo.isUnderWater &&
                    getCourantYoCoord(mission, index) &&
                    hasMeanCourant(mission, yo.yosCycle) &&
                    isInTimeLineRange(mission.misId, index)
                  "
                  :properties="{
                    type: 'courant',
                    missionid: mission.misId,
                    key: mission.misLibelle,
                    courant: getMeanCourant(mission, yo.yosCycle),
                    currentMin: mapstate.currentMin,
                    currentMax: mapstate.currentMax,
                    currentZoom: mapstate.currentZoom,
                    pos: getCourantYoCoord(mission, index),
                  }"
                  :key="'C' + yo.yosCycle + '_m' + mission.misId"
                >
                  <template slot-scope="feature">
                    <vl-geom-point :coordinates="getCourantYoCoord(mission, index)"></vl-geom-point>
                  </template>
                </vl-feature>
              </template>
            </template>
            <!-- dernier point toujours en rouge -->
            <vl-feature
              v-if="zoom >= getBestZoom(mission) && getLastYoCoord(mission)"
              :properties="{ type: 'lastyo', missionid: mission.misId, mission }"
              :key="'LY' + mission.misId"
            >
              <template slot-scope="feature">
                <vl-geom-point :coordinates="getLastYoCoord(mission)"></vl-geom-point>
              </template>
            </vl-feature>
            <!-- fleches de cap du glider sélectionné  -->
            <template
              v-if="
                mapstate.showHeading &&
                (missionDetailVisibility?.[mission.misId] || infosMissionIds.some(id => mission.misId == id)) &&
                zoom >= getBestZoom(mission) /*&& rangeLength(mission) < 400*/
              "
            >
              <vl-feature
                v-if="
                  (yo.heading || yo.heading == 0) &&
                  yo.heading != -9999 &&
                  yo.yoGpsLat &&
                  yo.yoGpsLon &&
                  isInTimeLineRange(mission.misId, index)
                "
                :properties="{ type: 'cap', missionid: mission.misId, key: mission.misLibelle, yo }"
                v-for="(yo, index) in mission.yoArray"
                :key="'H' + yo.yosCycle + '_m' + mission.misId"
              >
                <template slot-scope="feature">
                  <vl-geom-point :coordinates="[yo.yoGpsLon, yo.yoGpsLat]"></vl-geom-point>
                </template>
              </vl-feature>
            </template>
            <template v-if="hasCurrentCoord(mission)">
              <!-- target waypoint du glider sélectionné  -->
              <template v-if="hasGliderWayPointCoord(mission)">
                <vl-feature
                  :properties="{ type: 'waypoint', missionid: mission.misId }"
                  v-if="
                    mapstate.showWaypoint &&
                    (missionDetailVisibility?.[mission.misId] || infosMissionIds.some(id => mission.misId == id)) &&
                    zoom >= getBestZoom(mission)
                  "
                  :key="'W' + mission.misId"
                >
                  <template slot-scope="feature">
                    <vl-geom-point :coordinates="gliderWayPointCoord(mission)"></vl-geom-point>
                  </template>
                </vl-feature>
                <!-- lignes pointillés du waypoint du glider sélectionné -->
                <vl-feature
                  :properties="{ type: 'waypointstroke', missionid: mission.misId }"
                  v-if="
                    mapstate.showWaypoint &&
                    (missionDetailVisibility?.[mission.misId] || infosMissionIds.some(id => mission.misId == id)) &&
                    zoom >= getBestZoom(mission) &&
                    getLastYoCoord(mission)
                  "
                  :key="'WL' + mission.misId"
                >
                  <template slot-scope="feature">
                    <vl-geom-line-string
                      :coordinates="[getLastYoCoord(mission), gliderWayPointCoord(mission)]"
                    ></vl-geom-line-string>
                  </template>
                </vl-feature>
              </template>
              <!-- icone du glider positionné en fonction de la time line -->
              <vl-feature
                :properties="{
                  type: 'mission',
                  missionid: mission.misId,
                  mission,
                  selected: infosMissionIds.some(id => mission.misId == id),
                }"
                :key="'G' + mission.misId"
              >
                <template slot-scope="feature">
                  <vl-geom-point :coordinates="getCurrentCoord(mission)"></vl-geom-point>
                </template>
              </vl-feature>
            </template>
          </template>
          <template v-for="mission in visibleMission">
            <!-- //Mission Plan  -->
            <template
              v-if="
                (mapstate.showMissionPlan ||
                  (isMissionPlanEditable && !isFleetDetailMap) ||
                  (isFleetMissionPlanOpen && currentFleetMapState.selectedMissionPlanMissionId == mission.misId)) &&
                mission.covId == null &&
                missionPlanStateByMisid?.[mission.misId]?.missionPlan
              "
            >
              <!-- validation on map -->
              <vl-feature
                v-for="(step, index) in missionPlanStateByMisid[mission.misId].missionPlan.steps"
                v-if="
                  (missionPlanStateByMisid?.[mission.misId]?.missionPlan?.cur_step == step.id ||
                    missionPlanStateByMisid?.[mission.misId]?.hoverStepId == step.id ||
                    mapstate?.showMissionPlanValidation) &&
                  step.rVal > 0
                "
                :properties="{
                  missionid: mission.misId,
                  type: 'validationStepCircle',
                  rVal: $options.filters.formatDistance(step.rVal),
                  tVal: step.tVal == 0 ? 'none' : $options.filters.formatDuration(step.tVal * 60000, $i18n),
                }"
                :key="'VST' + mission.misId + '_' + step.id"
              >
                <template slot-scope="feature">
                  <vl-geom-circle
                    :radius="getUnitForMeters(stepsLineCoords[mission.misId][index][1], parseFloat(step.rVal))"
                    :coordinates="stepsLineCoords[mission.misId][index][1]"
                  ></vl-geom-circle>
                </template>
              </vl-feature>
              <!-- Way Point on Map -->
              <vl-feature
                v-for="wpt in missionPlanStateByMisid[mission.misId].missionPlan.wpts.filter(
                  w => !isMissionPlanEditable || w.id != missionPlanStateByMisid[mission.misId].currentEditWpt.id,
                )"
                :properties="{
                  missionid: mission.misId,
                  type:
                    missionPlanStateByMisid[mission.misId].hoverWptId == wpt.id ||
                    (missionPlanStateByMisid[mission.misId].hoverStepId != -1 &&
                      stepsById[mission.misId][missionPlanStateByMisid[mission.misId].hoverStepId].wpt_id == wpt.id)
                      ? 'hoverWayPoint'
                      : missionPlanStateByMisid[mission.misId].missionPlan.cur_step != -1 &&
                        stepsById[mission.misId][missionPlanStateByMisid[mission.misId].missionPlan.cur_step] &&
                        stepsById[mission.misId][missionPlanStateByMisid[mission.misId].missionPlan.cur_step].wpt_id ==
                          wpt.id
                      ? 'curWayPoint'
                      : 'wayPoint',
                  wpt_id: wpt.id,
                  wpt_label: isMissionPlanEditable ? '' : formatWaypoint(wpt),
                }"
                :key="'WP' + mission.misId + '_' + wpt.id"
              >
                <template slot-scope="feature">
                  <vl-geom-point :coordinates="[wpt.wpt_lon, wpt.wpt_lat]"></vl-geom-point>
                </template>
              </vl-feature>
              <!-- Stepson Map -->
              <vl-feature
                v-for="(step, index) in missionPlanStateByMisid[mission.misId].missionPlan.steps"
                :properties="{
                  missionid: mission.misId,
                  type:
                    missionPlanStateByMisid[mission.misId].hoverStepId == step.id
                      ? 'hoverStep'
                      : missionPlanStateByMisid[mission.misId].missionPlan.cur_step == step.id
                      ? 'currentMpStep'
                      : 'step',
                  step_id: step.id,
                }"
                :key="'ST' + mission.misId + '_' + step.id"
              >
                <template slot-scope="feature">
                  <vl-geom-line-string :coordinates="stepsLineCoords[mission.misId][index]"></vl-geom-line-string>
                </template>
              </vl-feature>
              <vl-feature
                v-if="missionPlanStateByMisid?.[mission.misId].lastActionId != -1"
                :properties="{
                  missionid: mission.misId,
                  type: 'backStep',
                  step_id: missionPlanStateByMisid[mission.misId].lastActionId,
                }"
                :key="'LP' + mission.misId"
              >
                <template slot-scope="feature">
                  <vl-geom-line-string :coordinates="lastPath[mission.misId]"></vl-geom-line-string>
                </template>
              </vl-feature>
            </template>
          </template>
          <template v-if="isFleetDetailMap">
            <!-- Coverage Grid point -->
            <vl-feature
              ref="coverageGridPoints"
              v-if="coverageGridPoints.length"
              :properties="{ fleId: $store.myGetters.modifiedAdmAdminFleet.FLE_ID, type: 'coverageGrid' }"
              :key="`GRID_${$store.myGetters.modifiedAdmAdminFleet.FLE_ID}`"
            >
              <vl-geom-multi-point :coordinates="coverageGridPoints"></vl-geom-multi-point>
            </vl-feature>
          </template>
          <!-- Coverage -->
          <template v-if="editCoverageState && !editCoverageState.saving">
            <!-- Coverage area -->
            <vl-feature
              v-if="$store.myGetters.modifiedAdmMissionGlobal?.config?.coverage_area?.length"
              :properties="{ migId: $store.myGetters.modifiedAdmMissionGlobal.MIG_ID, type: 'coverageArea' }"
              :key="`COV_${$store.myGetters.modifiedAdmMissionGlobal.MIG_ID}`"
            >
              <vl-geom-polygon :coordinates="coverageAreaCoords"></vl-geom-polygon>
            </vl-feature>
            <!-- Exclude areas -->
            <vl-feature
              v-for="excl in excludeAreasCoords"
              v-if="excl.nbPts"
              :properties="{
                migId: $store.myGetters.modifiedAdmMissionGlobal.MIG_ID,
                type: editCoverageState.hoverAreaId == excl.id ? 'hoverExcludeArea' : 'excludeArea',
              }"
              :key="`EXCL_${$store.myGetters.modifiedAdmMissionGlobal.MIG_ID}_${excl.id}`"
            >
              <vl-geom-polygon :coordinates="excl.excludeAreaCoords"></vl-geom-polygon>
            </vl-feature>
            <!-- Coverage Grid point -->
            <vl-feature
              ref="coverageGridPoints"
              v-if="coverageGridPoints.length"
              :properties="{ migId: $store.myGetters.modifiedAdmMissionGlobal.MIG_ID, type: 'coverageGrid' }"
              :key="`GRID_${$store.myGetters.modifiedAdmMissionGlobal.MIG_ID}`"
            >
              <vl-geom-multi-point :coordinates="coverageGridPoints"></vl-geom-multi-point>
            </vl-feature>
            <vl-feature
              v-if="deploymentCovPoint && zoom > 6"
              :properties="{ migId: $store.myGetters.modifiedAdmMissionGlobal.MIG_ID, type: 'deployment' }"
              :key="`DEP_${$store.myGetters.modifiedAdmMissionGlobal.MIG_ID}`"
            >
              <vl-geom-point :coordinates="deploymentCovPoint"></vl-geom-point>
            </vl-feature>
            <vl-feature
              v-if="recoveryCovPoint && zoom > 6"
              :properties="{ migId: $store.myGetters.modifiedAdmMissionGlobal.MIG_ID, type: 'recovery' }"
              :key="`REC_${$store.myGetters.modifiedAdmMissionGlobal.MIG_ID}`"
            >
              <vl-geom-point :coordinates="recoveryCovPoint"></vl-geom-point>
            </vl-feature>
            <!-- Cov Point on Map -->
            <vl-feature
              v-for="covPt in allCovWayPoint.filter(
                w => !isSmartCoverageEditable || w.wpt.id != editCoverageState.currentEditWpt.id,
              )"
              :properties="{
                type: editCoverageState.hoverWptKey == covPt.key ? 'hoverWayPoint' : 'wayPoint',
                wpt_key: covPt.key,
                wpt_label: isSmartCoverageEditable ? '' : formatWaypoint(covPt.wpt),
              }"
              :key="'WP' + covPt.key"
            >
              <template slot-scope="feature">
                <vl-geom-point :coordinates="covPt.position"></vl-geom-point>
              </template>
            </vl-feature>
          </template>
          <!--editMissionPlan-->
          <!-- //Mission Plan  -->
          <template
            v-if="
              (isSimuMissionPlanOpen || isFormationBarycenterMissionPlanVisible) &&
              editMissionPlanState &&
              editMissionPlanState.missionPlan
            "
          >
            <!-- validation on map -->
            <vl-feature
              v-for="(step, index) in editMissionPlanState.missionPlan.steps"
              v-if="
                (editMissionPlanState.missionPlan.cur_step == step.id ||
                  editMissionPlanState.hoverStepId == step.id ||
                  mapstate.showMissionPlanValidation) &&
                step.rVal > 0
              "
              :properties="{
                type: 'validationStepCircle',
                rVal: $options.filters.formatDistance(step.rVal),
                tVal: step.tVal == 0 ? 'none' : $options.filters.formatDuration(step.tVal * 60000, $i18n),
              }"
              :key="'VST' + step.id"
            >
              <template slot-scope="feature">
                <vl-geom-circle
                  :radius="getUnitForMeters(editStepsLineCoords[index][1], parseFloat(step.rVal))"
                  :coordinates="editStepsLineCoords[index][1]"
                ></vl-geom-circle>
              </template>
            </vl-feature>
            <!-- Way Point on Map -->
            <vl-feature
              v-for="wpt in editMissionPlanState.missionPlan.wpts.filter(
                w => !isMissionPlanEditable || w.id != editMissionPlanState.currentEditWpt.id,
              )"
              :properties="{
                type:
                  editMissionPlanState.hoverWptId == wpt.id ||
                  (editMissionPlanState.hoverStepId != -1 &&
                    editStepsById[editMissionPlanState.hoverStepId].wpt_id == wpt.id)
                    ? 'hoverWayPoint'
                    : editMissionPlanState.missionPlan.cur_step != -1 &&
                      editStepsById[editMissionPlanState.missionPlan.cur_step] &&
                      editStepsById[editMissionPlanState.missionPlan.cur_step].wpt_id == wpt.id
                    ? 'curWayPoint'
                    : 'wayPoint',
                wpt_id: wpt.id,
                wpt_label: isMissionPlanEditable ? '' : formatWaypoint(wpt),
              }"
              :key="'WP' + wpt.id"
            >
              <template slot-scope="feature">
                <vl-geom-point :coordinates="[wpt.wpt_lon, wpt.wpt_lat]"></vl-geom-point>
              </template>
            </vl-feature>
            <!-- Stepson Map -->
            <vl-feature
              v-for="(step, index) in editMissionPlanState.missionPlan.steps"
              :properties="{
                type:
                  editMissionPlanState.hoverStepId == step.id
                    ? 'hoverStep'
                    : editMissionPlanState.missionPlan.cur_step == step.id
                    ? 'currentMpStep'
                    : 'step',
                step_id: step.id,
              }"
              :key="'ST' + step.id"
            >
              <template slot-scope="feature">
                <vl-geom-line-string :coordinates="editStepsLineCoords[index]"></vl-geom-line-string>
              </template>
            </vl-feature>
            <vl-feature
              v-if="editMissionPlanState.lastActionId != -1"
              :properties="{ type: 'backStep', step_id: editMissionPlanState.lastActionId }"
              :key="'LP'"
            >
              <template slot-scope="feature">
                <vl-geom-line-string :coordinates="editLastPath"></vl-geom-line-string>
              </template>
            </vl-feature>
          </template>
        </vl-source-vector>

        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <!--editCoverage-->
      <template v-if="isSmartCoverageEditable && editCoverageState && !editCoverageState.saving">
        <vl-overlay
          v-if="canRenderOverlay"
          v-show="!hideOverlay && !editCoverageState.currentEditWpt.id && editCoverageState.drawMode == ''"
          v-for="covPt in allCovWayPoint"
          :position="covPt.position"
          positioning="bottom-center"
          :offset="[0, -15]"
          :key="'Over' + covPt.key"
        >
          <template slot-scope="scope">
            <v-menu top offset-y>
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  class="tooltip-map"
                  :class="{ hover: editCoverageState.hoverWptKey == covPt.key }"
                  @mouseover="onCoveragePointHover(covPt)"
                  @mouseleave="editCoverageState.hoverWptKey = ''"
                  @dblclick="editCoveragePoint(covPt)"
                >
                  {{ formatWaypoint(covPt.wpt) }}
                </div>
              </template>
              <v-list>
                <v-list-tile @click="editCoveragePoint(covPt)">
                  <v-list-tile-avatar><v-icon>mdi-pencil</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('Admin.MissionPlanTemplate.Form.Edit') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="deleteCoveragePoint(covPt)">
                  <v-list-tile-avatar><v-icon>mdi-delete</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('Admin.MissionPlanTemplate.Form.DeleteWaypoint') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
        </vl-overlay>
      </template>
      <template v-if="isMissionPlanEditable && !editCoverageState">
        <vl-overlay
          v-if="canRenderOverlay"
          v-show="!hideOverlay && !editMissionPlanState.currentEditWpt.id"
          v-for="wpt in editMissionPlanState.missionPlan.wpts"
          :position="[wpt.wpt_lon, wpt.wpt_lat]"
          positioning="bottom-center"
          :offset="[0, -15]"
          :key="'Over' + wpt.id"
        >
          <template slot-scope="scope">
            <v-menu top offset-y>
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  class="tooltip-map"
                  :class="{ hover: editMissionPlanState.hoverWptId == wpt.id }"
                  @mouseover="editMissionPlanState.hoverWptId = wpt.id"
                  @mouseleave="editMissionPlanState.hoverWptId = -1"
                  @dblclick="editWaypoint(wpt)"
                >
                  {{ formatWaypoint(wpt) }}
                </div>
              </template>
              <v-list>
                <v-list-tile @click="editWaypoint(wpt)">
                  <v-list-tile-avatar><v-icon>mdi-pencil</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('Admin.MissionPlanTemplate.Form.Edit') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="addNewStep(wpt)">
                  <v-list-tile-avatar><v-icon>mdi-playlist-plus</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('Admin.MissionPlanTemplate.Form.AddStep') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="editMissionPlanState.missionPlan.steps.findIndex(s => s.wpt_id == wpt.id) == -1"
                  @click="deleteWaypoint(wpt)"
                >
                  <v-list-tile-avatar><v-icon>mdi-delete</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('Admin.MissionPlanTemplate.Form.DeleteWaypoint') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
        </vl-overlay>
      </template>

      <!-- PopUp Glider -->
      <vl-overlay
        v-if="canRenderOverlay"
        v-show="!hideOverlay && hover_misison && hover_misison.misId > 0"
        positioning="bottom-center"
        :position="getCurrentCoord(hover_misison)"
        :offset="[0, -15]"
      >
        <template slot-scope="scope">
          <div class="tooltip-measure">
            {{ hover_misison && hover_misison.misLibelle }}
          </div>
        </template>
      </vl-overlay>
      <!-- PopUp Yo ou Courant ou Cap -->
      <vl-overlay
        v-if="canRenderOverlay"
        v-show="!hideOverlay && yo_type == 'yo' && hover_yo && hover_yo.yosCycle > 0"
        positioning="bottom-center"
        :position="[hover_yo ? hover_yo.yoGpsLon : 0, hover_yo ? hover_yo.yoGpsLat : 0]"
        :offset="[0, -15]"
      >
        <template slot-scope="scope">
          <div class="tooltip-measure">
            {{ hover_yo && hover_yo.yoGpsDatTime | formatDate }}
            <br />
            cycle {{ hover_yo && hover_yo.yosCycle }}
          </div>
        </template>
      </vl-overlay>
      <vl-overlay
        v-if="canRenderOverlay && yo_type == 'step' && hover_step && hover_step.Cycle_number > 0"
        v-show="!hideOverlay"
        positioning="bottom-center"
        :position="[hover_step.WPV_diving_point_longitude, hover_step.WPV_diving_point_latitude]"
        :offset="[0, -15]"
      >
        <template slot-scope="scope">
          <div class="tooltip-measure">
            {{ new Date(hover_step.startTime) | formatDate }}
            <br />
            cycle {{ hover_step.Cycle_number }}
            <br />
            cap {{ hover_step.Hc_course_heading_deg }}°
          </div>
        </template>
      </vl-overlay>
      <vl-overlay
        v-if="canRenderOverlay && yo_type == 'courant' && hover_courant"
        v-show="!hideOverlay"
        positioning="bottom-center"
        :position="hover_courant.pos"
        :offset="[0, -20]"
      >
        <template slot-scope="scope">
          <div class="tooltip-measure">
            {{ $t('Pilot.MissionDrawer.CurrentHeading') }}: {{ hover_courant.mean && hover_courant.mean.cr }} °
            <br />
            {{ $t('Pilot.MissionDrawer.CurrentSpeed') }}: {{ hover_courant.mean && hover_courant.mean.cf }} m/s
          </div>
        </template>
      </vl-overlay>
      <!-- draw components -->
      <vl-overlay
        v-if="canRenderOverlay && mapReady && measureTool != 'NONE' && measureText != null"
        v-show="!hideOverlay"
        :position="measureCoord"
        positioning="bottom-center"
        :offset="[0, -15]"
      >
        <template slot-scope="scope">
          <div class="tooltip-measure" v-html="measureText"></div>
        </template>
      </vl-overlay>
      <vl-layer-vector v-if="mapReady && measureTool != 'NONE'" id="draw-pane" ref="drPane" :zIndex="200">
        <vl-source-vector :ident="drawTargetIdent" :features.sync="measuresFeatures"></vl-source-vector>
      </vl-layer-vector>
      <vl-interaction-draw
        :maxPoints="measureTool == 'PROFILE_DEPTH' || measureTool == 'BEARING' ? 2 : 0"
        :condition="drawCondition"
        ref="draw"
        v-if="mapReady && measureTool != 'NONE'"
        @drawend="onDrawend"
        @drawstart="onDrawstart"
        :source="drawTargetIdent"
        :type="drawType"
      ></vl-interaction-draw>
      <vl-layer-vector
        v-if="
          mapReady &&
          ((isSingleWayPointModuleVisibleOnScreen && isSingleWayPointModuleActive && !isGlobal) ||
            maptype == 'picker' ||
            isParameterVisible)
        "
        :zIndex="200"
      >
        <vl-source-vector :ident="gliderWayPointIdent">
          <vl-feature
            :properties="{
              type: maptype == 'simulation' ? 'deployPoint' : undefined,
              wpt_label: maptype == 'simulation' ? $t('Simulation.WaypointInit') : '',
            }"
          >
            <template slot-scope="feature">
              <vl-geom-point ref="wayPoint" :coordinates="gliderModifiedWayPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-modify
        v-if="
          mapReady &&
          ((isSingleWayPointModuleVisibleOnScreen && isSingleWayPointModuleActive && !isGlobal) ||
            maptype == 'picker' ||
            isParameterVisible)
        "
        :source="gliderWayPointIdent"
        @modifyend="onModifyend"
      ></vl-interaction-modify>
      <vl-layer-vector
        v-if="
          mapReady &&
          isQuickControlModuleVisibleOnScreen &&
          isQuickControlModuleActive &&
          !isGlobal &&
          quickControlWayPointCoord
        "
        :zIndex="200"
      >
        <vl-source-vector :ident="quickControlWayPointIdent">
          <vl-feature :properties="{ wpt_label: 'EasyWaypoint' }">
            <template slot-scope="feature">
              <vl-geom-point ref="quickControlWayPoint" :coordinates="quickControlWayPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-modify
        v-if="
          mapReady &&
          isQuickControlModuleVisibleOnScreen &&
          isQuickControlModuleActive &&
          !isGlobal &&
          quickControlWayPointCoord
        "
        :source="quickControlWayPointIdent"
        @modifyend="onQuickControlModifyend"
      ></vl-interaction-modify>
      <vl-layer-vector
        v-if="
          mapReady &&
          isSingleWayPointModuleVisibleOnScreen &&
          isSingleWayPointModuleActive &&
          !isGlobal &&
          singleWayPointIsDirty
        "
        :zIndex="199"
      >
        <vl-source-vector :ident="singleWayPointOriginalIdent">
          <vl-feature :properties="{ type: 'pendingwaypoint' }">
            <template slot-scope="feature">
              <vl-geom-point :coordinates="gliderModifiedWayPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
          <vl-feature
            v-if="getLastYoCoord(currentDetailMission.mission)"
            :properties="{ type: 'pendingwaypointstroke' }"
          >
            <template slot-scope="feature">
              <vl-geom-line-string
                :coordinates="[getLastYoCoord(currentDetailMission.mission), gliderModifiedWayPointCoord]"
              ></vl-geom-line-string>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-layer-vector
        v-if="mapReady && isQuickControlModuleVisibleOnScreen && !isGlobal && quickControlIsDirty"
        :zIndex="199"
      >
        <vl-source-vector :ident="quickControlOriginalIdent">
          <vl-feature :properties="{ type: 'pendingwaypoint' }">
            <template slot-scope="feature">
              <vl-geom-point :coordinates="quickControlWayPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
          <vl-feature
            v-if="getLastYoCoord(currentDetailMission.mission)"
            :properties="{ type: 'pendingwaypointstroke' }"
          >
            <template slot-scope="feature">
              <vl-geom-line-string
                :coordinates="[getLastYoCoord(currentDetailMission.mission), quickControlWayPointCoord]"
              ></vl-geom-line-string>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-layer-vector
        v-if="mapReady && editCoverageState && editCoverageState.currentEditWpt.id && editCoverageState.drawMode == ''"
        :zIndex="200"
      >
        <vl-source-vector :ident="coveragePointIdent">
          <vl-feature
            :properties="{
              type: editCoverageState.editAreaId == -1 ? 'deployPoint' : 'deployPoint',
              wpt_label: editCoverageState.currentEditWpt.wpt_label,
            }"
          >
            <template slot-scope="feature">
              <vl-geom-point ref="covPoint" :coordinates="coverageModifiedPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-modify
        v-if="editCoverageState && editCoverageState.currentEditWpt.id"
        :source="coveragePointIdent"
        @modifyend="onModifyCoveragePointend"
      ></vl-interaction-modify>
      <!--// draw components -->
      <!-- //CUSTOM LAYERS -->
      <vl-layer-vector
        v-if="mapReady"
        :zIndex="400"
        :opacity="(mapstate.layermapOpacity[layer.id] === 0 ? 0 : mapstate.layermapOpacity[layer.id] || 100) / 100.0"
        v-for="layer in layers.filter(l => l.LAY_DATA && l.LAY_DATA.length > 0)"
        :key="`kml_${layer.id}`"
      >
        <vl-source-vector :features="custFeatures(layer)" :format-factory="kmlFactory"></vl-source-vector>
      </vl-layer-vector>
      <vl-layer-vector
        :zIndex="401"
        v-if="mapReady && isMissionPlanEditable && editMissionPlanState.currentEditWpt.id > 0 && currentEditWptCoord"
      >
        <!-- Way Point on Map -->
        <vl-source-vector ref="wayPointIdent" :ident="wayPointIdent">
          <vl-feature :properties="{ type: 'modifyWayPoint', wpt_id: editMissionPlanState.currentEditWpt.id }">
            <template slot-scope="feature">
              <vl-geom-point ref="modWaypoint" :coordinates="currentEditWptCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-modify
        v-if="mapReady && isMissionPlanEditable && editMissionPlanState.currentEditWpt.id > 0 && currentEditWptCoord"
        @modifyend="onMissionPlanModifyend"
        :source="wayPointIdent"
      ></vl-interaction-modify>
      <vl-layer-vector :zIndex="402" v-if="mapReady && isMissionPlanEditable && editMissionPlanState.drawMode != ''">
        <!-- Way Point on Map -->
        <vl-source-vector ref="newWayPointIdent" :ident="newWayPointIdent">
          <vl-feature
            v-if="editMissionPlanState.currentEditWpt.id > 0 && currentEditWptCoord"
            :properties="{ type: 'modifyWayPoint', wpt_id: editMissionPlanState.currentEditWpt.id }"
          >
            <template slot-scope="feature">
              <vl-geom-point :coordinates="currentEditWptCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-draw
        v-if="mapReady && isMissionPlanEditable && editMissionPlanState.drawMode != ''"
        :condition="drawCondition"
        @drawend="onMissionPlanDrawend"
        :source="newWayPointIdent"
        type="Point"
      ></vl-interaction-draw>
      <vl-layer-vector
        :zIndex="402"
        v-if="mapReady && isSmartCoverageEditable && editCoverageState && editCoverageState.drawMode != ''"
      >
        <!-- Cov Point on Map -->
        <vl-source-vector ref="newCovPointIdent" :ident="newCovPointIdent">
          <vl-feature
            v-if="
              isSmartCoverageEditable &&
              editCoverageState &&
              editCoverageState.currentEditWpt.id > 0 &&
              coverageModifiedPointCoord
            "
            :properties="{ type: 'modifyWayPoint', wpt_id: editCoverageState.currentEditWpt.id }"
          >
            <template slot-scope="feature">
              <vl-geom-point ref="modCovpoint" :coordinates="coverageModifiedPointCoord"></vl-geom-point>
            </template>
          </vl-feature>
        </vl-source-vector>
        <vl-style-func :factory="mapStylesFunction" />
      </vl-layer-vector>
      <vl-interaction-draw
        v-if="mapReady && isSmartCoverageEditable && editCoverageState?.drawMode == 'wpt'"
        :condition="drawCondition"
        @drawend="onCoverageDrawend"
        :source="newCovPointIdent"
        type="Point"
      ></vl-interaction-draw>
      <vl-interaction-draw
        v-if="
          mapReady &&
          isSmartCoverageEditable &&
          (editCoverageState?.drawMode == 'RECOVERY' || editCoverageState?.drawMode == 'DEPLOYMENT')
        "
        :condition="drawCondition"
        @drawend="onDepRecoveryDrawEnd"
        :source="newCovPointIdent"
        type="Point"
      ></vl-interaction-draw>
    </vl-map>
    <map-context-menu :uiid="uiid" ref="menu">
      <v-list-tile
        v-if="isQuickControlModuleVisibleOnScreen && isQuickControlModuleActive"
        @click="setQuickControlTargetFromContext"
      >
        <v-list-tile-avatar><v-icon>mdi-map-marker-radius</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{ $t('Pilot.QuickControl.EasyWaypoint.SetTargetHere') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="isSingleWayPointModuleVisibleOnScreen && isSingleWayPointModuleActive"
        @click="setSingleWayPointTargetFromContext"
      >
        <v-list-tile-avatar><v-icon>mdi-map-marker-radius</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{ $t('Pilot.SingleWayPoint.SetTargetHere') }}</v-list-tile-title>
      </v-list-tile>
    </map-context-menu>
    <map-mission-context-menu :uiid="uiid" ref="missionmenu" />
    <map-mission-plan-context-menu :uiid="uiid" :missionPlanStateUiid="editMissionPlanStateUiid" ref="missionplanmenu">
      <map-tool-list :uiid="uiid" />
    </map-mission-plan-context-menu>
    <map-coverage-context-menu v-if="editCoverageState" :coverageState="editCoverageState" ref="coveragemenu">
      <map-tool-list :uiid="uiid" />
    </map-coverage-context-menu>
    <v-toolbar
      v-if="isMissionPlanEditable && editMissionPlanState.currentEditWpt.id"
      style="position: absolute; bottom: 20px; left: 50px; width: auto"
    >
      <v-toolbar-title>
        <v-text-field hide-details type="text" v-model="editMissionPlanState.currentEditWpt.wpt_label" />
        {{ toCoordString(editMissionPlanState.currentEditWpt) }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn class="ml-4" small @click="cancelWaypoint()" title="Annuler">
          {{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn small @click="updateWaypoint()" title="valider">
          {{ $t('Admin.MissionPlanTemplate.Form.Valid') }}
          <v-icon right>mdi-check-circle</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar
      v-if="editCoverageState && editCoverageState.currentEditWpt.id"
      style="position: absolute; bottom: 20px; left: 50px; width: auto"
    >
      <v-toolbar-title>
        <v-text-field hide-details type="text" v-model="editCoverageState.currentEditWpt.wpt_label" />
        {{ toCoordString(editCoverageState.currentEditWpt) }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn class="ml-4" small @click="cancelCoveragePoint()" title="Annuler">
          {{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn small @click="updateCoveragePoint()" title="valider">
          {{ $t('Admin.MissionPlanTemplate.Form.Valid') }}
          <v-icon right>mdi-check-circle</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar
      v-if="isMissionPlanEditable && editMissionPlanState.drawMode != ''"
      style="position: absolute; bottom: 20px; left: 50px; width: auto"
    >
      <v-spacer />
      <v-toolbar-items>
        <v-btn small @click="editMissionPlanState.drawMode = ''" title="Annuler">
          Stop drawing
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar
      v-if="isSmartCoverageEditable && editCoverageState && editCoverageState.drawMode != ''"
      style="position: absolute; bottom: 20px; left: 50px; width: auto"
    >
      <v-spacer />
      <v-toolbar-items>
        <v-btn small @click="editCoverageState.drawMode = ''" title="Annuler">
          Stop drawing
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar v-if="hoverProfil != ''" style="position: absolute; top: 10px; left: 45px; width: 90%; height: 20px">
      <v-toolbar-items>
        <strong>{{ hoverProfil }}</strong>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar v-if="hoverProfilSci != ''" style="position: absolute; top: 30px; left: 45px; width: 90%; height: 20px">
      <v-toolbar-items>
        <strong>{{ hoverProfilSci }}</strong>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar v-if="measureTool != 'NONE'" style="position: absolute; bottom: 20px; left: 50px; width: auto">
      <v-spacer />
      <v-toolbar-items>
        <v-btn small @click="$store.myActions.UI_SET_MEASURETOOL('NONE')" title="Annuler">
          Stop drawing
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>
<script>
//import * as ol from 'ol'

import * as extent from 'ol/extent'
import * as proj from 'ol/proj'
import Graticule from 'ol/Graticule'
import Text from 'ol/style/Text'
import Circle from 'ol/geom/Circle'
import LineString from 'ol/geom/LineString'
import Polygon from 'ol/geom/Polygon'
import MousePosition from 'ol/control/MousePosition'
import ScaleLine from 'ol/control/ScaleLine'
import * as sphere from 'ol/sphere'
import * as condition from 'ol/events/condition'
import { unByKey } from 'ol/Observable'
import bearing from '@turf/bearing'
import KML from 'ol/format/KML.js'
import { toNumberDictionary } from '@/utils/groupBy'
import { mapGetters } from 'vuex'
import { MeasureToolType } from '@/enum/MeasureToolType'

import 'ol/ol.css'
import * as mapStyles from '@/components/map/MapStyles'
import MapContextMenu from '@/components/map/MapContextMenu'
import MapMissionContextMenu from '@/components/map/MapMissionContextMenu'
import MapMissionPlanContextMenu from '@/components/map/MapMissionPlanContextMenu'
import MapCoverageContextMenu from '@/components/map/MapCoverageContextMenu'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'
import { GLIDER_MODE } from '../../models/alo/AloMission'
import { buildMissionPlanStateId, MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import MapToolList from '@/components/map/MapToolList'
import { LayerConfig } from '@/models/ui/LayerConfig'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { LayerSourceType } from '@/enum/LayerSourceType'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
import {
  isAloDbMissionGlobalCoverage,
  isAloDbMissionGlobalFormation,
  isAloDbMissionGlobalSimulator,
} from '@/models/alodb/AloDbMissionGlobal'
import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'
import { buildCoverageIterationUiStateId } from '@/models/ui/CoverageIterationUiState'
//import OLCesium from 'olcs/OLCesium.js'

export default {
  name: 'Map',
  components: { MapContextMenu, MapMissionContextMenu, MapMissionPlanContextMenu, MapCoverageContextMenu, MapToolList },
  props: {
    uiid: {
      type: String,
      required: true,
      default: 'map_global',
    },
    maptype: {
      type: String,
      required: true,
      default: 'mission',
    },
    value: {
      type: Array,
      default: () => [0, 0],
    },
  },
  data() {
    const grat = new Graticule({
      showLabels: true,
      latLabelStyle: new Text({
        font: '12px Calibri,sans-serif',
        textAlign: 'end',
        offsetX: -34,
      }),
      lonLabelStyle: new Text({
        font: '12px Calibri,sans-serif',
        textBaseline: 'bottom',
      }),
    })
    return {
      curCoord: null,
      hover_misison: null,
      hover_yo: null,
      hover_step: null,
      hover_courant: null,
      measuresFeatures: [],
      yo_type: '',
      zoom: 2,
      center: [0, 0],
      mouseControl: {},
      cursorHover: false,
      cursorHelp: false,
      graticule: grat,
      //defaultGraticuleLatLabelFormatter_:grat.latLabelFormatter_,
      //defaultGraticuleLonLabelFormatter_:grat.lonLabelFormatter_,
      measureListener: null,
      moveListener: null,
      wheelListener: null,
      currentMeasureFeature: null,
      measureText: null,
      measureCoord: [0, 0],
      mapReady: false,
      isMissionPlanEditable: false,
      isSmartCoverageEditable: false,
      hoverProfil: '',
      hoverProfilSci: '',
      scrollDelta: 50,
      lastScrollZoom: null,
      hideOverlay: false,
      canRenderOverlay: true,
      timeCacheAis: 1000 * 60 * 5,
      timeCacheGliderOnline: 1000 * 20,
      nbGliderOnline: 0,
      nbGliderOnlineFirst: 0,
      lastAisRefreshTime: null,
      checkTimeCacheAisID: null,
      contextMenuCoord: null,
    }
  },
  computed: {
    ...mapGetters([
      'uistatebyuiid',
      'missionMapVisibility',
      'simulationMapVisibility',
      'smartPlanningUiState',
      'simulationDetailVisibility',
      'missionDetailVisibility',
      'drawerMissions',
      'currentMissionMapId',
      'currentDetailFleet',
      'currentDetailMission',
      'coordFormatFilter',
      'measureTool',
      'drawType',
      'isSingleWayPointModuleVisible',
      'isMissionPlanModuleVisible',
      'isQuickControlModuleVisible',
      'isFleetFormationParameterVisible',
      'isFleetFormationParameterOpen',
      'isFleetMissionPlanModuleOpen',
      'filterMission',
      'isOperator',
      'isSysAdmin',
    ]),
    darkModeStyles() {
      return {
        filter: 'invert(95%) hue-rotate(180deg)',
      }
    },
    darkmode() {
      return this.$store.myGetters.darkmode
    },
    //Getter pour edition mission plan
    sensorById() {
      return toNumberDictionary(this.editMissionPlanState.missionPlan.payload ?? [], it => it.id)
    },
    editWptsById() {
      return toNumberDictionary(this.editMissionPlanState?.missionPlan?.wpts ?? [], it => it.id)
    },
    editStepsById() {
      return toNumberDictionary(this.editMissionPlanState?.missionPlan?.steps ?? [], it => it.id)
    },
    editPrf_navById() {
      return toNumberDictionary(this.editMissionPlanState?.missionPlan?.prf_nav ?? [], it => it.id)
    },
    editSensorById() {
      return toNumberDictionary(this.editMissionPlanState?.missionPlan?.payload ?? [], it => it.id)
    },
    editPrf_sciById() {
      return toNumberDictionary(this.editMissionPlanState?.missionPlan?.prf_sci ?? [], it => it.id)
    },
    editStepsLineCoords() {
      let coords = []
      if ((this.editMissionPlanState?.missionPlan?.steps?.length ?? 0) > 0) {
        const wpt = this.editWptsById[this.editMissionPlanState.missionPlan.steps[0].wpt_id]
        let prev = [wpt.wpt_lon - 0.01, wpt.wpt_lat - 0.01]
        coords = this.editMissionPlanState.missionPlan.steps.map(s => {
          const wpt = this.editWptsById[s.wpt_id]
          const path = [prev, [wpt.wpt_lon, wpt.wpt_lat]]
          prev = [wpt.wpt_lon, wpt.wpt_lat]
          return path
        })
      }
      return coords
    },
    editLastPath() {
      if (
        (this.editMissionPlanState?.missionPlan?.steps?.length ?? 0) > 0 &&
        this.editMissionPlanState.lastActionId != -1
      ) {
        const lastWpt =
          this.editWptsById[
            this.editMissionPlanState.missionPlan.steps[this.editMissionPlanState.missionPlan.steps.length - 1].wpt_id
          ]
        const newStartWpt = this.editWptsById[this.editStepsById[this.editMissionPlanState.lastActionId].wpt_id]
        //console.log([[lastWpt.wpt_lon,lastWpt.wpt_lat],[newStartWpt.wpt_lon,newStartWpt.wpt_lat]])
        return [
          [lastWpt.wpt_lon, lastWpt.wpt_lat],
          [newStartWpt.wpt_lon, newStartWpt.wpt_lat],
        ]
      }
      return []
    },
    isDetailMap() {
      return this.uiid.indexOf('MissionDetailMap') == 0
    },
    isFleetDetailMap() {
      return this.uiid.indexOf('fleet_') == 0
    },
    isSimulationMap() {
      return this.uiid.indexOf('simulation_') == 0
    },
    selectedFilterEnsIds() {
      return this.filterMission?.ensIds?.at(0) ?? undefined
    },
    misEnsIds() {
      return this.isDetailMap
        ? this.currentDetailMission?.mission?.ensId ?? undefined
        : this.isFleetDetailMap
        ? this.currentDetailFleet?.fleet?.ensId ?? undefined
        : this.isSimulationMap
        ? this.$store.myGetters.originalAdmMissionGlobal?.ENS_ID ?? undefined
        : this.selectedFilterEnsIds
    },
    layermaps() {
      //cas des layer globaux ou enseigne
      const layers = this.layers.reduce((layers, layer) => {
        //if(this.mapReady && (this.mapstate.layermapVisibility[layer.id] || this.mapstate.baseMapLayer.id == layer.id)) {
        if (this.mapReady) {
          const config =
            this.mapstate.layermapconfig[layer.id] ??
            new LayerConfig(JSON.parse((layer.LAY_CONFIG_JSON?.length ?? 0) > 0 ? layer.LAY_CONFIG_JSON : '{}'))
          if (config.type != LayerSourceType.NONE) {
            layers.push(AloDbMapLayer.toOlLayerConfig(layer.id, config))
          }
        }
        return layers
      }, [])
      if (this.mapstate.showAis && this.mapReady) {
        /*this.visibleMission
          .filter(m => m.misActifOn)*/
        this.missionPlanMission.forEach(m => {
          const aisLayer = {
            id: `AIS_${m.misId}`,
            cmp: 'vl-layer-tile',
            source: {
              cmp: 'vl-source-wms',
              url: `/api/georequester/${m.misId}/ais/`,
              layers: 'vesselLayer',
              loader: 'vl-loader-wms',
              projection: 'EPSG:4326',
              maxZoom: 39,
              //projection: 'EPSG:404000',
              extParams: {
                version: '1.3.0',
                format: 'image/png',
                transparent: true,
                cache: Math.round(Date.now() / this.timeCacheAis), //cache de 5 minutes
                online: m.gliderWaitingMode != GLIDER_MODE.GLIDER_MODE_DISCONNECTED, //changement de cache si le glider surface
              },
            },
          }
          let aisStart = this.mapstate.aisStartDateUtc
          let aisEnd = this.mapstate.aisEndDateUtc
          if (!aisStart) {
            const endDate = new Date()
            endDate.setMinutes(0, 0, 0)
            endDate.setHours(endDate.getHours())
            if (new Date().getMinutes() < 30) {
              endDate.setHours(endDate.getHours() - 1)
            }
            aisStart = endDate.toISOString()
          }
          if (!aisEnd) {
            const endDate = new Date()
            endDate.setMinutes(0, 0, 0)
            endDate.setHours(endDate.getHours() + 1)
            aisEnd = endDate.toISOString()
          }

          //CQL_FILTER=ts%20DURING%202026-01-07T12:30:00Z/2026-01-07T15:30:00Z
          //aisLayer.source.extParams.CQL_FILTER = `ts >= '${aisStart}'`
          aisLayer.source.extParams.CQL_FILTER = `ts DURING ${aisStart}/${aisEnd}`
          layers.push(aisLayer)
        })
      }
      return layers
    },
    layers() {
      return this.$store.myGetters.mapLayers.filter(
        layer =>
          (((((layer.LAY_SCOPE != 'MIS' && layer.LAY_SCOPE != 'MIG') ||
            (this.isDetailMap && layer.LAY_SCOPE == 'MIS' && layer.MIS_ID == this.currentDetailMission.mission.misId) ||
            (this.isSimulationMap &&
              layer.LAY_SCOPE == 'MIG' &&
              layer.MIG_ID == this.$store.myGetters.originalAdmMissionGlobal.id)) &&
            this.mapstate.layermapVisibility[layer.id]) ||
            //test si le layer est un layer a afficher pour les mission en mode detail
            (this.mapstate.showMissionLayer && this.isInMissionLayer(layer))) &&
            ((!this.isOperator && !this.isSysAdmin) ||
              this.misEnsIds == undefined ||
              layer.LAY_SCOPE != 'ENS' ||
              layer.ENS_ID == this.misEnsIds)) ||
          //cas des layer mission
          (this.mapstate.showMissionLayer &&
            layer.LAY_SCOPE == 'MIS' &&
            this.visibleMission.some(m => layer.MIS_ID == m.misId) &&
            (this.missionDetailVisibility[layer.MIS_ID] || this.infosMissionIds.some(id => layer.MIS_ID == id))) ||
          //cas des smart simulation
          (this.mapstate.showMissionLayer &&
            layer.LAY_SCOPE == 'MIG' &&
            this.visibleMission.some(
              m =>
                (this.$store.myGetters.missionGlobalsById[layer.MIG_ID]?.misIdArray?.some(id => id == m.misId) ??
                  false) &&
                (this.missionDetailVisibility[m.misId] || this.infosMissionIds.some(id => m.misId == id)),
            )) ||
          //cas du baseLayer mission
          this.mapstate.baseMapLayer.id == layer.id,
      )
    },
    globalWpts() {
      return this.$store.myGetters.positionRemarquables.map(p => {
        return { id: p.id, wpt_label: p.prmLibelle, wpt_lat: p.gpsLat, wpt_lon: p.gpsLon }
      })
    },
    isSingleWayPointModuleVisibleOnScreen() {
      return this.mapstate.typeUiid == 'detail' && this.maptype == 'mission' && this.isSingleWayPointModuleVisible
    },
    isQuickControlModuleVisibleOnScreen() {
      return (
        this.mapstate.typeUiid == 'detail' &&
        this.maptype == 'mission' &&
        this.isQuickControlModuleVisible &&
        // RG-ACC-054 — module Quick Control de l'enseigne du planeur
        !!this.$store.getters.enseigneConfigFor(this.currentDetailMission?.mission?.ensId)?.quickcontrol_on
      )
    },
    buildSimulationUIStateId() {
      return buildSimulationUIStateId
    },
    isMissionPlanEditableToWatch() {
      return (
        ((this.mapstate.typeUiid == 'detail' &&
          ((this.maptype == 'mission' && this.isMissionPlanModuleVisible) ||
            (this.maptype == 'simulation' &&
              this.$store.myGetters.isSmartMissionPlanModuleVisible(
                buildSimulationUIStateId(this.$store.myGetters?.modifiedAdmMissionGlobal?.MIG_ID || -1, 'detail'),
              )))) ||
          (this.mapstate.typeUiid == 'fleet' && this.maptype == 'fleet' && this.isFleetFormationParameterVisible)) &&
        !!this.editMissionPlanState
      )
    },
    isSmartCoverageEditableToWatch() {
      return (
        this.maptype == 'simulation' &&
        this.$store.myGetters.isSmartCoverageParameterModuleVisible(
          buildSimulationUIStateId(this.$store.myGetters?.modifiedAdmMissionGlobal?.MIG_ID || -1, 'detail'),
        )
      )
    },
    isSimuMissionPlanOpen() {
      return (
        this.mapstate.typeUiid == 'detail' &&
        this.maptype == 'simulation' &&
        this.$store.myGetters.isSmartMissionPlanModuleOpen(
          buildSimulationUIStateId(this.$store.myGetters?.modifiedAdmMissionGlobal?.MIG_ID || -1, 'detail'),
        )
      )
    },
    isFormationBarycenterMissionPlanVisible() {
      return this.mapstate.typeUiid == 'fleet' && this.maptype == 'fleet' && this.isFleetFormationParameterVisible
    },
    isFleetMissionPlanOpen() {
      return this.mapstate.typeUiid == 'fleet' && this.maptype == 'fleet' && this.isFleetMissionPlanModuleOpen
    },
    isParameterVisible() {
      return false //this.maptype == 'simulation' && this.$store.myGetters.isSmartParameterModuleVisible(buildSimulationUIStateId(this.$store.myGetters.modifiedAdmMissionGlobal.MIG_ID || -1,"detail") )
    },
    editMissionPlanState() {
      return this.uistatebyuiid(this.editMissionPlanStateUiid) //this.missionPlanStateByMisid[this.currentDetailMissionId]
    },
    currentEditWptCoord() {
      return [
        parseFloat(this.editMissionPlanState.currentEditWpt.wpt_lon),
        parseFloat(this.editMissionPlanState.currentEditWpt.wpt_lat),
      ]
    },
    editMissionPlanStateUiid() {
      return this.maptype == 'mission'
        ? buildMissionPlanStateId(this.currentDetailMissionId, 'mission')
        : this.maptype == 'fleet'
        ? buildMissionPlanStateId(this.$store.myGetters?.modifiedAdmAdminFleet?.FLE_ID || -1, 'fleet')
        : buildMissionPlanStateId(this.$store.myGetters?.modifiedAdmMissionGlobal?.MIG_ID || -1, 'simulation')
    },
    //recupere le state de travail
    mapstate() {
      //retourne un MapUiState
      return this.uistatebyuiid(this.uiid)
    },
    driftActivated() {
      return this.mapstate.showDrift
    },
    currentDetailMissionId() {
      return this.maptype == 'simulation' || this.isGlobal
        ? null //this.$store.myGetters.originalAdmMissionGlobal?.misIdArray?.map(id => this.$store.myGetters.missionVirtualsById[id]?.mission)?.filter(m => !!m)?.at(0)?.misId
        : this.currentDetailMission.mission.misId
    },
    missionPlanStateByMisid() {
      return this.missionPlanMission.reduce((dic, mis) => {
        const uiid = buildMissionPlanStateId(mis.misId, 'mission')
        this.$set(dic, mis.misId, this.uistatebyuiid(uiid))
        return dic
      }, {})
    },
    stepsById() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId])
          this.$set(
            dic,
            mis.misId,
            toNumberDictionary(this.missionPlanStateByMisid[mis.misId].missionPlan.steps, it => it.id),
          )
        return dic
      }, {})
    },
    wptsById() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId])
          this.$set(
            dic,
            mis.misId,
            toNumberDictionary(this.missionPlanStateByMisid[mis.misId].missionPlan.wpts, it => it.id),
          )
        return dic
      }, {})
    },
    prf_navById() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId])
          this.$set(
            dic,
            mis.misId,
            toNumberDictionary(this.missionPlanStateByMisid[mis.misId].missionPlan.prf_nav, it => it.id),
          )
        return dic
      }, {})
    },
    prf_sciById() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId])
          this.$set(
            dic,
            mis.misId,
            toNumberDictionary(this.missionPlanStateByMisid[mis.misId].missionPlan.prf_sci, it => it.id),
          )
        return dic
      }, {})
    },
    stepsLineCoords() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId]) {
          let coords = []
          if (this.missionPlanStateByMisid[mis.misId].missionPlan.steps.length > 0) {
            const wpt = this.wptsById[mis.misId][this.missionPlanStateByMisid[mis.misId].missionPlan.steps[0].wpt_id]
            let prev = [wpt.wpt_lon - 0.01, wpt.wpt_lat - 0.01]
            coords = this.missionPlanStateByMisid[mis.misId].missionPlan.steps.map(s => {
              const wpt = this.wptsById[mis.misId][s.wpt_id]
              const path = [prev, [wpt.wpt_lon, wpt.wpt_lat]]
              prev = [wpt.wpt_lon, wpt.wpt_lat]
              return path
            })
          }
          this.$set(dic, mis.misId, coords)
        }
        return dic
      }, {})
    },
    lastPath() {
      return this.missionPlanMission.reduce((dic, mis) => {
        if (this.missionPlanStateByMisid[mis.misId]) {
          if (
            this.missionPlanStateByMisid[mis.misId].missionPlan.steps &&
            this.missionPlanStateByMisid[mis.misId].missionPlan.steps.length > 0 &&
            this.missionPlanStateByMisid[mis.misId].lastActionId != -1
          ) {
            const lastWpt =
              this.wptsById[mis.misId][
                this.missionPlanStateByMisid[mis.misId].missionPlan.steps[
                  this.missionPlanStateByMisid[mis.misId].missionPlan.steps.length - 1
                ].wpt_id
              ]
            const newStartWpt =
              this.wptsById[mis.misId][
                this.stepsById[mis.misId][this.missionPlanStateByMisid[mis.misId].lastActionId].wpt_id
              ]
            //console.log([[lastWpt.wpt_lon,lastWpt.wpt_lat],[newStartWpt.wpt_lon,newStartWpt.wpt_lat]])
            this.$set(dic, mis.misId, [
              [lastWpt.wpt_lon, lastWpt.wpt_lat],
              [newStartWpt.wpt_lon, newStartWpt.wpt_lat],
            ])
          } else {
            this.$set(dic, mis.misId, [])
          }
        }
        return dic
      }, {})
    },
    currentFleetMapState() {
      return this.uistatebyuiid(buildFleetUIStateId(this.currentDetailFleet.fleet.FLE_ID, 'detail'))
    },
    fleetMapVisibility() {
      return this.currentFleetMapState.missionMapVisibility
    },
    showGraticule() {
      return !!this.mapstate.showGraticule
    },
    refreshBestFit() {
      return this.mapstate.refreshBestFit
    },
    refreshMap() {
      return this.mapstate.refreshMap
    },
    showEndMissionSimulation() {
      return this.currentDetailMissionId
        ? this.missionAbsState(this.currentDetailMissionId).showRemainingNavigation
        : false
    },
    visibleMission() {
      return this.visibleMissionRaw.filter(m => this.getPath(m).length > 0)
    },
    visibleMissionRaw() {
      //Carte en Mode Mission
      if (this.maptype == 'mission') {
        if (this.isGlobal) {
          //Carte Globale
          return this.drawerMissions.filter(m => this.missionMapVisibility[m.misId])
        }
        //Carte Détail
        //Mission avec simulation et simulation visible
        else if (this.currentDetailMission.mission.hasEndMissionSimulation && this.showEndMissionSimulation) {
          return [this.currentDetailMission.mission, this.currentDetailMission.mission.simulation]
        }
        //Mission
        else {
          return [this.currentDetailMission.mission]
        }
      }
      //Carte en Mode Simulation
      else if (this.maptype == 'simulation') {
        //Carte Globale
        if (this.isGlobal) {
          // BLF037 — scénarios autorisés pour leur enseigne seulement (RG-ACC-050).
          return this.$store.myGetters.smartScenarios
            .filter(
              m =>
                isAloDbMissionGlobalSimulator(m) &&
                ((this.smartPlanningUiState.filterMission?.length ?? 0) == 0 ||
                  (m.MIG_LIBELLE?.toLowerCase() ?? '').indexOf(this.smartPlanningUiState.filterMission.toLowerCase()) >
                    -1) &&
                ((this.smartPlanningUiState.filterTypePlanif?.length ?? 0) == 0 ||
                  (m?.config?.processing_mode?.toLowerCase() ?? '') ==
                    this.smartPlanningUiState.filterTypePlanif.toLowerCase()) &&
                //@ts-ignore
                ((this.$store.myGetters.filterMission?.ensIds?.length ?? 0) == 0 ||
                  m.ENS_ID == this.$store.myGetters.filterMission?.ensIds?.at(0)),
            )
            .map(m => {
              const maxVimId = Math.max(...m.misIdArray, -1)
              return {
                simulation: m,
                misVirtual: m.config?.templateSimId
                  ? this.$store.myGetters.missionVirtualsById[m.config?.templateSimId] ?? null
                  : this.$store.myGetters.missionVirtualsById[maxVimId] ?? null,
              }
            })
            .filter(
              m =>
                ((this.smartPlanningUiState.filterDateStart?.length ?? 0) == 0 ||
                  (m?.misVirtual?.param?.mission_start_date &&
                    new Date(m.misVirtual.param.mission_start_date) >=
                      new Date(this.smartPlanningUiState.filterDateStart))) &&
                ((this.smartPlanningUiState.filterDateEnd?.length ?? 0) == 0 ||
                  (m?.misVirtual?.param?.mission_start_date &&
                    new Date(m.misVirtual.param.mission_start_date) <=
                      new Date(this.smartPlanningUiState.filterDateEnd))) &&
                this.simulationMapVisibility[m.simulation.id],
            )
            .map(m => m.misVirtual?.mission)
            .filter(m => !!m)
        }
        //Carte Détail
        else {
          //mission coverage
          if (
            isAloDbMissionGlobalCoverage(this.$store.myGetters.originalAdmMissionGlobal) ||
            isAloDbMissionGlobalFormation(this.$store.myGetters.originalAdmMissionGlobal)
          ) {
            const coverage_uiid = buildCoverageStateId(this.$store.myGetters.originalAdmMissionGlobal.MIG_ID, 'detail')
            const coverageState = this.$store.myGetters.coverageStateByUiid(coverage_uiid)
            const covIteration = coverageState.selectedCoverageId
              ? this.$store.myGetters.coverageIterationsById[coverageState.selectedCoverageId]
              : null
            if (covIteration) {
              const gliderKeys = Object.keys(covIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER'))
              return gliderKeys.map(k => covIteration?.resultAloMission?.[k]).filter(m => !!m)
            } else return []
          } else {
            return this.$store.myGetters.originalAdmMissionGlobal.misIdArray
              .map(id => this.$store.myGetters.missionVirtualsById[id]?.mission)
              .filter(m => !!m)
              .filter(m => this.missionMapVisibility[m.misId])
          }
        }
      }
      //Carte en Mode Picker
      else if (this.maptype == 'picker') {
        return []
      }
      //Carte détail en mode fleet
      else {
        return this.missions.filter(m => this.fleetMapVisibility[m.misId])
      }
    },
    missionPlanMission() {
      return this.maptype == 'mission' || this.maptype == 'simulation'
        ? this.visibleMission.filter(
            m =>
              !m.covId &&
              (this.missionDetailVisibility[m.misId] ||
                m.misId == this.currentMissionMapId ||
                m.misId == this.currentDetailMissionId),
          )
        : this.missions.filter(m => this.fleetMapVisibility[m.misId])
    },
    isGlobal() {
      return this.mapstate.typeUiid == 'global'
    },
    infosMissionIds() {
      if (this.maptype == 'mission') {
        const missionArr = []
        if (this.isGlobal) {
          if (this.currentMissionMapId > 0) missionArr.push(this.currentMissionMapId)
        } else {
          if (this.currentDetailMission && this.currentDetailMission.mission.misId > 0) {
            missionArr.push(this.currentDetailMission.mission.misId)
            if (this.currentDetailMission.mission.hasEndMissionSimulation && this.showEndMissionSimulation)
              missionArr.push(this.currentDetailMission.mission.simulation.misId)
          }
        }
        return missionArr
      } else if (this.maptype == 'simulation') {
        return this.mapstate.bestFitMisId > 0 ? [this.mapstate.bestFitMisId] : []
      } else if (this.maptype == 'picker') {
        return []
      } else {
        return this.currentDetailFleet ? this.currentDetailFleet.fleet.param?.missionIds : []
      }
    },
    missions() {
      return this.infosMissionIds
        .map(misId =>
          this.maptype == 'simulation'
            ? this.$store.myGetters.missionVirtualsById[misId].mission
            : this.$store.myGetters.missionsById[misId],
        )
        .filter(m => !!m)
    },
    drawTargetIdent() {
      return `drawtarget_${this.uiid}`
    },
    gliderWayPointIdent() {
      return `gliderWayPointIdent_${this.uiid}`
    },
    quickControlWayPointIdent() {
      return `quickControlWayPointIdent_${this.uiid}`
    },
    singleWayPointOriginalIdent() {
      return `singleWayPointOriginalIdent_${this.uiid}`
    },
    quickControlOriginalIdent() {
      return `quickControlOriginalIdent_${this.uiid}`
    },
    coveragePointIdent() {
      return `coveragePointIdent_${this.uiid}`
    },
    wayPointIdent() {
      return `wayPointIdent_${this.uiid}`
    },
    newWayPointIdent() {
      return `newWayPointIdent_${this.uiid}`
    },
    newCovPointIdent() {
      return `newCovPointIdent${this.uiid}`
    },
    isSingleWayPointModuleActive() {
      if (
        this.currentDetailMission &&
        this.currentDetailMission.mission &&
        this.currentDetailMission.mission.misActifOn
      ) {
        const originalSingleWayPointConfig =
          this.$store.myGetters.originalSingleWayPointConfigs[this.currentDetailMission.mission.gliId]
        if (originalSingleWayPointConfig)
          return originalSingleWayPointConfig.mod_settings.EnabledMOD['module-SingleWayPoint']
        else return false
      } else {
        return false
      }
    },
    gliderModifiedWayPointCoord() {
      if (this.maptype == 'picker') {
        //@ts-ignore
        return [this.value?.at(1) ?? 0, this.value?.at(0) ?? 0]
      } else if (this.currentDetailMission && this.currentDetailMission.mission) {
        /*else if(this.maptype == 'simulation') {
          //return [this.$store.myGetters.modifiedAdmMissionGlobal?.config?.wpt_init?.at(1)??0,this.$store.myGetters.modifiedAdmMissionGlobal?.config?.wpt_init?.at(0)??0]
        }*/
        const modifiedSingleWayPointConfig =
          this.$store.myGetters.modifiedSingleWayPointConfigs[this.currentDetailMission.mission.gliId]
        if (modifiedSingleWayPointConfig) {
          return [
            modifiedSingleWayPointConfig.mod_settings.SingleWayPoint_target.lon_target,
            modifiedSingleWayPointConfig.mod_settings.SingleWayPoint_target.lat_target,
          ]
        }
      }
    },
    isQuickControlModuleActive() {
      if (this.currentDetailMission && this.currentDetailMission.mission) {
        const originalQuickControlConfig =
          this.$store.myGetters.originalQuickControlConfigs[this.currentDetailMission.mission.misId]
        if (originalQuickControlConfig)
          return originalQuickControlConfig.mod_settings?.EnabledMOD?.['module-QuickControl'] === true
      }
      return false
    },
    quickControlWayPointCoord() {
      if (this.currentDetailMission && this.currentDetailMission.mission) {
        const modifiedConfig =
          this.$store.myGetters.modifiedQuickControlConfigs[this.currentDetailMission.mission.misId]
        const ew = modifiedConfig?.mod_settings?.QuickControl_easywaypoint
        if (ew && ew.lat_target != null && ew.lon_target != null) {
          return [ew.lon_target, ew.lat_target]
        }
      }
      return undefined
    },
    singleWayPointOriginalCoord() {
      if (this.maptype == 'picker') return undefined
      if (this.currentDetailMission && this.currentDetailMission.mission) {
        const originalConfig =
          this.$store.myGetters.originalSingleWayPointConfigs[this.currentDetailMission.mission.gliId]
        if (originalConfig) {
          return [
            originalConfig.mod_settings.SingleWayPoint_target.lon_target,
            originalConfig.mod_settings.SingleWayPoint_target.lat_target,
          ]
        }
      }
      return undefined
    },
    singleWayPointIsDirty() {
      const orig = this.singleWayPointOriginalCoord
      const mod = this.gliderModifiedWayPointCoord
      if (!mod) return false
      if (!orig) return true
      return orig[0] !== mod[0] || orig[1] !== mod[1]
    },
    quickControlOriginalCoord() {
      if (this.currentDetailMission && this.currentDetailMission.mission) {
        const originalConfig =
          this.$store.myGetters.originalQuickControlConfigs[this.currentDetailMission.mission.misId]
        const ew = originalConfig?.mod_settings?.QuickControl_easywaypoint
        if (ew && ew.lat_target != null && ew.lon_target != null) {
          return [ew.lon_target, ew.lat_target]
        }
      }
      return undefined
    },
    quickControlIsDirty() {
      const orig = this.quickControlOriginalCoord
      const mod = this.quickControlWayPointCoord
      if (!mod) return false
      if (!orig) return true
      return orig[0] !== mod[0] || orig[1] !== mod[1]
    },
    ////////TODO APRES CELA C'EST TEMPORAIRE JUSTE POUR DEMO DES AREA
    editCoverageState() {
      return this.editCoverageStateUiid ? this.$store.myGetters.coverageStateByUiid(this.editCoverageStateUiid) : null
    },
    editCoverageStateUiid() {
      if (
        this.maptype == 'simulation' &&
        this.mapstate.typeUiid == 'detail' &&
        isAloDbMissionGlobalCoverage(this.$store.myGetters.modifiedAdmMissionGlobal)
      )
        return buildCoverageStateId(this.$store.myGetters?.modifiedAdmMissionGlobal?.MIG_ID || -1, 'detail')
      else return null
    },
    coverageModifiedPointCoord() {
      return [
        this.editCoverageState?.currentEditWpt?.wpt_lon || 0,
        this.editCoverageState?.currentEditWpt?.wpt_lat || 0,
      ]
    },
    coverageWptList() {
      return (this.editCoverageState?.editAreaId ?? -1) > 0
        ? this.$store.myGetters.modifiedAdmMissionGlobal?.config?.exclude_areas?.find(
            a => a.id == this.editCoverageState?.editAreaId,
          )?.area_pts
        : this.$store.myGetters.modifiedAdmMissionGlobal?.config?.coverage_area
    },
    coverageWptsById() {
      return toNumberDictionary(this.coverageWptList ?? [], it => it.id)
    },
    coverageAreaCoords() {
      if (!this.editCoverageState) return [[]]
      else {
        const pts = this.$store.myGetters.modifiedAdmMissionGlobal?.config?.coverage_area?.map(it =>
          this.editCoverageState?.editAreaId == -1 && this.editCoverageState?.currentEditWpt?.id == it.id
            ? [this.editCoverageState?.currentEditWpt?.wpt_lon, this.editCoverageState?.currentEditWpt?.wpt_lat]
            : [it?.wpt_lon, it?.wpt_lat],
        )
        return [pts]
      }
    },
    excludeAreasCoords() {
      if (!this.editCoverageState) return [[[]]]
      else {
        return this.$store.myGetters.modifiedAdmMissionGlobal?.config?.exclude_areas?.map(a => {
          const pts = a.area_pts.map(it =>
            this.editCoverageState.editAreaId == a.id && this.editCoverageState?.currentEditWpt?.id == it.id
              ? [this.editCoverageState.currentEditWpt.wpt_lon, this.editCoverageState.currentEditWpt.wpt_lat]
              : [it.wpt_lon, it.wpt_lat],
          )
          return { id: a.id, nbPts: a.area_pts?.length, excludeAreaCoords: [pts] }
        })
      }
    },
    coverageGridPoints() {
      return this.maptype == 'simulation'
        ? this.$store.myGetters.modifiedAdmMissionGlobal?.resultGridJson?.wpts?.map(w => [w.wpt_lon, w.wpt_lat]) || []
        : this.maptype == 'fleet'
        ? this.$store.myGetters.modifiedAdmAdminFleet?.resultGridJson?.wpts?.map(w => [w.wpt_lon, w.wpt_lat]) || []
        : []
    },
    deploymentCovPoint() {
      return this.coverageGridPoints?.length &&
        this.$store.myGetters.modifiedAdmMissionGlobal?.config?.deployment_mode == 'common'
        ? this.coverageGridPoints?.at(
            this.$store.myGetters.modifiedAdmMissionGlobal?.resultGridJson?.wpts.findIndex(
              w => w.id == this.$store.myGetters.modifiedAdmMissionGlobal?.config?.deployment_point,
            ) ?? 0,
          )
        : null
    },
    recoveryCovPoint() {
      return this.coverageGridPoints?.length &&
        this.$store.myGetters.modifiedAdmMissionGlobal?.config?.recovery_mode == 'common'
        ? this.coverageGridPoints?.at(
            this.$store.myGetters.modifiedAdmMissionGlobal?.resultGridJson?.wpts.findIndex(
              w => w.id == this.$store.myGetters.modifiedAdmMissionGlobal?.config?.recovery_point,
            ) ?? 0,
          )
        : null
    },
    allCovWayPoint() {
      return isAloDbMissionGlobalCoverage(this.$store.myGetters.modifiedAdmMissionGlobal)
        ? [
            ...this.$store.myGetters.modifiedAdmMissionGlobal?.config?.coverage_area?.map(pt => ({
              key: `-1_${pt.id}`,
              position: [pt.wpt_lon, pt.wpt_lat],
              areaId: -1,
              wpt: pt,
            })),
            ...this.$store.myGetters.modifiedAdmMissionGlobal?.config?.exclude_areas?.flatMap(a =>
              a.area_pts.map(pt => ({
                key: `${a.id}_${pt.id}`,
                position: [pt.wpt_lon, pt.wpt_lat],
                areaId: a.id,
                wpt: pt,
              })),
            ),
          ]
        : []
    },
  },
  mounted() {
    this.checkTimeCacheAisID = setInterval(() => {
      const nbOnline = this.missionPlanMission.filter(
        m => m.gliderWaitingMode != GLIDER_MODE.GLIDER_MODE_DISCONNECTED,
      ).length
      if (!this.lastAisRefreshTime) {
        this.lastAisRefreshTime = Date.now()
        this.nbGliderOnline = nbOnline
        this.nbGliderOnlineFirst = nbOnline
      } else if (
        Date.now() - this.lastAisRefreshTime >
        (this.nbOnline > this.nbGliderOnlineFirst ? this.timeCacheGliderOnline : this.timeCacheAis)
      ) {
        this.lastAisRefreshTime = Date.now()
        this.nbGliderOnlineFirst = nbOnline
        if (this.mapstate.showAis) {
          this.mapstate.showAis = false
          this.$nextTick(() => (this.mapstate.showAis = true))
        }
      } //force un sechond check pour etre certain d'un refresh apres un changement de nbOnline apres le temps impartis
      else if (
        Date.now() - this.lastAisRefreshTime >
        (this.nbOnline > this.nbGliderOnline ? this.timeCacheGliderOnline : this.timeCacheAis)
      ) {
        if (this.mapstate.showAis) {
          this.lastAisRefreshTime = Date.now()
          this.nbGliderOnline = nbOnline
          if (this.mapstate.showAis) {
            this.mapstate.showAis = false
            this.$nextTick(() => (this.mapstate.showAis = true))
          }
        }
      }
    }, 1000)
  },
  watch: {
    value() {
      if (this.maptype == 'picker') {
        this.goTo(this.gliderModifiedWayPointCoord)
      }
    },
    refreshBestFit() {
      this.goToBestFit(
        this.mapstate.bestFitMisId == -1
          ? this.missions
          : [
              this.maptype == 'simulation'
                ? this.$store.myGetters.missionVirtualsById[this.mapstate.bestFitMisId]?.mission
                : this.$store.myGetters.missionsById[this.mapstate.bestFitMisId],
            ],
      )
    },
    refreshMap() {
      this.redrawMap()
    },
    layermaps: {
      handler: function (newValue) {
        this.hideOverlay = true
        this.$nextTick(() => (this.canRenderOverlay = false))
        setTimeout(() => {
          this.hideOverlay = false
          this.$nextTick(() => (this.canRenderOverlay = true))
        }, 100)
        //07/05/24 Commente la correction suite a refonte simulation voir si pb apparait en prod plus tard ou non
        // setTimeout(()=>{
        //   this.canRenderOverlay = false
        //   setTimeout(()=> {
        //       this.canRenderOverlay = true
        //       setTimeout(()=> this.hideOverlay = false,200)
        //   },250)
        // },250)
      },
      deep: true,
    },
    layers(newLayers) {
      newLayers.forEach(layer => {
        this.$store.myActions.MAPLAYER_ENSURE_DETAIL(layer.id)
      })
    },
    coordFormatFilter(newFormat) {
      if (this.mouseControl.setCoordinateFormat) this.mouseControl.setCoordinateFormat(this.$options.filters[newFormat])
      this.updateGraticuleFormat()
    },
    showGraticule(show) {
      if (this.$refs.map) this.graticule.setMap(show ? this.$refs.map.$map : null)
    },
    measureTool(newValue) {
      if (newValue == MeasureToolType.NONE) {
        this.currentMeasureFeature = null
        this.measureText = null
        this.measuresFeatures = []
      } else {
        this.$nextTick(() => {
          this.updateWaypoint()
          //désactive l'edition ou l'ajout de waypoint et de step...
          if (this.editMissionPlanState && this.editMissionPlanState?.drawMode != '') {
            this.editMissionPlanState.drawMode = ''
          }
        })
      }
    },
    uiid(newValue) {
      if (!this.isGlobal && this.$refs.map) {
        this.goToBestFit(this.missions, 0)
        this.zoom = this.mapstate.mapZoom
        this.center = this.mapstate.mapCenter
      }
    },
    infosMissionIds: {
      handler: function (newValue) {
        if (this.$refs.mapcontainer) this.$refs.mapcontainer.focus()
      },
      deep: true,
    },
    missionPlanMission(newValue) {
      this.onMissionPlanChanged()
    },
    isMissionPlanEditableToWatch(newValue) {
      if (!newValue) {
        if (this.editMissionPlanState) this.editMissionPlanState.drawMode = ''
        this.updateWaypoint()
      }
      //on execute seulement si isSmartCoverageEditable n'est pas visible sinon bug si visible alors le changement sera effectué dans l'autre watcher
      if (!this.isSmartCoverageEditableToWatch) {
        this.$nextTick(() => {
          this.isMissionPlanEditable = newValue
          this.$nextTick(() => (this.isSmartCoverageEditable = this.isSmartCoverageEditableToWatch))
        })
      }
    },
    isSmartCoverageEditableToWatch(newValue) {
      if (!newValue) {
        if (this.editCoverageState) this.editCoverageState.drawMode = ''
        this.updateCoveragePoint()
      }
      //on execute seulement si isMissionPlanEditable n'est pas visible sinon bug si visible alors le changement sera effectué dans l'autre watcher
      if (!this.isMissionPlanEditableToWatch) {
        this.$nextTick(() => {
          this.isSmartCoverageEditable = newValue
          this.$nextTick(() => (this.isMissionPlanEditable = this.isMissionPlanEditableToWatch))
        })
      }
    },
    driftActivated(newValue) {
      if (newValue) {
        this.$store.myActions.MISSION_ENSURE_DRIFT(this.currentDetailMissionId)
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.checkTimeCacheAisID)
    if (this.moveListener) unByKey(this.moveListener)
    if (this.wheelListener) unByKey(this.wheelListener)
  },
  methods: {
    stadiaTileLoadFunction(tile, src) {
      fetch(src, {
        referrer: window.location.origin,
        referrerPolicy: 'origin',
      })
        .then(response => response.blob())
        .then(blob => {
          tile.getImage().src = URL.createObjectURL(blob)
        })
    },
    checkAiRefresh() {
      this.lastAisRefresh = this.$store.myGetters.lastAiRefresh
    },
    onMissionPlanChanged() {
      this.missionPlanMission.forEach(mission => {
        if (this.maptype == 'simulation') {
          const mpuiid = buildMissionPlanStateId(mission.misId, 'mission')
          this.$store.myGetters.missionPlanUiStateByUiid(mpuiid).missionPlan =
            this.$store.myGetters.missionVirtualsById[mission.misId].param.mission_plan
        }
        //si pas simulation on regarde si on l'a déja recu d'iris
        else if (!this.$store.myGetters.originalIrisMissionPlan[mission.misId]) {
          this.$store.myActions.MISSION_IRIS_MISSION_PLAN_REQUEST(mission.misId).then(it => {
            this.missionPlanStateByMisid[mission.misId].missionPlan = MissionPlanUiState.parseMissionPlan(
              JSON.stringify(it),
            )
          })
        }
      })
    },
    isInMissionLayer(layer) {
      return (
        (layer?.MISSION_IDS?.some(
          mid =>
            this.visibleMission.some(m => mid == m.misId) &&
            (this.missionDetailVisibility[mid] || this.infosMissionIds.some(id => mid == id)),
        ) ??
          false) ||
        (layer?.MISSION_GLOBALE_IDS?.some(
          migId =>
            (this.maptype == 'simulation' &&
              this.mapstate.typeUiid == 'detail' &&
              this.$store.myGetters.originalAdmMissionGlobal?.id == migId) ||
            (this.$store.myGetters.missionGlobalsById[migId]?.misIdArray?.some(
              mid =>
                this.visibleMission.some(m => mid == m.misId) &&
                (this.missionDetailVisibility[mid] || this.infosMissionIds.some(id => mid == id)),
            ) ??
              false),
        ) ??
          false) ||
        (this.maptype == 'simulation' &&
          this.mapstate.typeUiid == 'detail' &&
          layer?.MIG_ID == this.$store.myGetters.originalAdmMissionGlobal?.id)
      )
    },
    editWaypoint(wpt) {
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      if (this.editMissionPlanState && this.editMissionPlanState?.drawMode != '') {
        this.editMissionPlanState.drawMode = ''
      }
      this.$nextTick(() => {
        this.editMissionPlanState.currentEditWpt = JSON.parse(JSON.stringify(wpt))
      })
    },
    formatWaypoint(wpt) {
      return wpt.wpt_label && wpt.wpt_label.length > 0 ? wpt.wpt_label : this.toCoordString(wpt)
    },
    updateWaypoint() {
      if (this.maptype != 'simulation' && this.maptype != 'fleet') {
        const wpt = this.wptsById[this.currentDetailMissionId][this.editMissionPlanState.currentEditWpt.id]
        if (wpt) {
          Object.keys(this.editMissionPlanState.currentEditWpt).forEach(key => {
            //@ts-ignore
            if (key == 'wpt_lat' || key == 'wpt_lon')
              wpt[key] = parseFloat(this.editMissionPlanState.currentEditWpt[key])
            //@ts-ignore
            else if (key != 'id') wpt[key] = this.editMissionPlanState.currentEditWpt[key]
          })
        }
      } else {
        const wpt = this.editWptsById[this.editMissionPlanState.currentEditWpt.id]
        if (wpt) {
          Object.keys(this.editMissionPlanState.currentEditWpt).forEach(key => {
            //@ts-ignore
            if (key == 'wpt_lat' || key == 'wpt_lon')
              wpt[key] = parseFloat(this.editMissionPlanState.currentEditWpt[key])
            //@ts-ignore
            else if (key != 'id') wpt[key] = this.editMissionPlanState.currentEditWpt[key]
          })
        }
      }
      this.cancelWaypoint()
    },
    cancelWaypoint() {
      this.editMissionPlanState.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
      this.editMissionPlanState.hoverWptId = -1
    },
    nextProfilId() {
      return this.editMissionPlanState.missionPlan.prf_nav.length > 0
        ? Math.max(...this.editMissionPlanState.missionPlan.prf_nav.map(i => i.id)) + 1
        : 1
    },
    nextProfilSciId() {
      return this.editMissionPlanState.missionPlan.prf_sci.length > 0
        ? Math.max(...this.editMissionPlanState.missionPlan.prf_sci.map(i => i.id)) + 1
        : 1
    },
    nextStepId() {
      return this.editMissionPlanState.missionPlan.steps.length > 0
        ? Math.max(...this.editMissionPlanState.missionPlan.steps.map(i => i.id)) + 1
        : 1
    },
    addNewStep(wpt) {
      //aucun profil n'existe on en crée un
      if (this.editMissionPlanState.missionPlan.prf_nav.length == 0)
        this.editMissionPlanState.missionPlan.prf_nav.push({
          ...MissionPlanUiState.getDefaultProfil(),
          id: this.nextProfilId(),
        })
      const lastProfil =
        this.editMissionPlanState.missionPlan.steps.length > 0
          ? this.editPrf_navById[
              this.editMissionPlanState.missionPlan.steps[this.editMissionPlanState.missionPlan.steps.length - 1]
                .prfNav_id
            ]
          : this.editMissionPlanState.missionPlan.prf_nav[this.editMissionPlanState.missionPlan.prf_nav.length - 1]

      //aucun profil sci n'existe on en crée un
      if (this.editMissionPlanState.missionPlan.prf_sci.length == 0)
        this.editMissionPlanState.missionPlan.prf_sci.push({
          ...MissionPlanUiState.getDefaultProfilSci(),
          id: this.nextProfilSciId(),
          prf_label: 'All on',
          sensors: this.editMissionPlanState.missionPlan.payload.reduce((s, it) => {
            s[it.id] = [1, '111', 1]
            return s
          }, {}),
        })
      const lastProfilSci =
        this.editMissionPlanState.missionPlan.steps.length > 0
          ? this.editPrf_sciById[
              this.editMissionPlanState.missionPlan.steps[this.editMissionPlanState.missionPlan.steps.length - 1]
                .prfSci_id
            ]
          : this.editMissionPlanState.missionPlan.prf_sci[this.editMissionPlanState.missionPlan.prf_sci.length - 1]

      const lastStep =
        this.editMissionPlanState.missionPlan.steps.length > 0
          ? this.editMissionPlanState.missionPlan.steps[this.editMissionPlanState.missionPlan.steps.length - 1]
          : MissionPlanUiState.getDefaultStep()
      const newStep = {
        ...lastStep,
        wpt_id: wpt.id,
        id: this.nextStepId(),
        prfNav_id: lastProfil?.id,
        prfSci_id: lastProfilSci?.id,
      }

      this.editMissionPlanState.missionPlan.steps.push(newStep)
      this.updateNextStep()
    },
    updateNextStep(stop = -1) {
      if (stop == -1) stop = this.editMissionPlanState.missionPlan.steps.length
      this.editMissionPlanState.missionPlan.steps.forEach((step, index) => {
        if (index > stop) return
        if (index < this.editMissionPlanState.missionPlan.steps.length - 1) {
          step.nextStep_id = this.editMissionPlanState.missionPlan.steps[index + 1].id
        } else {
          step.nextStep_id = step.id
        }
      })
      //affecte la derniere actions
      if (this.editMissionPlanState.missionPlan.steps.length > 0)
        this.editMissionPlanState.missionPlan.steps[
          this.editMissionPlanState.missionPlan.steps.length - 1
        ].nextStep_id =
          this.editMissionPlanState.lastActionId == -1
            ? this.editMissionPlanState.missionPlan.steps[this.editMissionPlanState.missionPlan.steps.length - 1].id
            : this.editMissionPlanState.lastActionId
    },
    deleteWaypoint(wpt) {
      this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteWaypointMessage').toString()).then(remove => {
        if (remove && this.editMissionPlanState.missionPlan.steps.findIndex(s => s.wpt_id == wpt.id) == -1) {
          //supprime le waypoint
          this.editMissionPlanState.missionPlan.wpts.splice(
            this.editMissionPlanState.missionPlan.wpts.findIndex(it => it.id == wpt.id),
            1,
          )
          //this.bestFit()
        }
      })
    },
    toCoordString(wpt) {
      return this.$options.filters[this.$store.myGetters.coordFormatFilter]([wpt.wpt_lon, wpt.wpt_lat])
    },
    missionState(missionId) {
      return this.uistatebyuiid(buildMissionUIStateId(missionId, this.mapstate.typeUiid))
    },
    missionAbsState(missionId) {
      return this.uistatebyuiid(buildMissionUIStateId(Math.abs(missionId), this.mapstate.typeUiid))
    },
    drawCondition(e) {
      return condition.noModifierKeys(e) && e.originalEvent.button != 2
    },
    onContextMenu(e) {
      this.contextMenuCoord = this.eventToLonLat(e)
      if (this.cursorHover) this.$refs.missionmenu.show(e, this.hover_misison.misId)
      else if (this.isMissionPlanEditable) this.$refs.missionplanmenu.show(e)
      else if (this.isSmartCoverageEditable) this.$refs.coveragemenu.show(e)
      else this.$refs.menu.show(e)
    },
    eventToLonLat(e) {
      const olMap = this.$refs.map?.$map
      if (!olMap) return null
      const coord3857 = olMap.getEventCoordinate(e)
      if (!coord3857) return null
      return proj.transform(coord3857, proj.get('EPSG:3857'), proj.get('EPSG:4326'))
    },
    setQuickControlTargetFromContext() {
      const coord = this.contextMenuCoord
      if (!coord || !this.currentDetailMission?.mission) return
      const misId = this.currentDetailMission.mission.misId
      this.updateQuickControlEasyWaypointTarget(misId, parseFloat(coord[1].toFixed(5)), parseFloat(coord[0].toFixed(5)))
    },
    updateQuickControlEasyWaypointTarget(misId, newLat, newLon) {
      const current = this.$store.myGetters.modifiedQuickControlConfigs[misId]
      if (!current) return
      const updated = JSON.parse(JSON.stringify(current))
      if (!updated.mod_settings) updated.mod_settings = {}
      const existing = updated.mod_settings.QuickControl_easywaypoint ?? {}
      updated.mod_settings.QuickControl_easywaypoint = { ...existing, lat_target: newLat, lon_target: newLon }
      this.$store.myActions.MISSION_UPDATE_MODIFIED_QUICKCONTROL_CONFIG({ itemId: misId, config: updated })
    },
    setSingleWayPointTargetFromContext() {
      const coord = this.contextMenuCoord
      if (!coord || !this.currentDetailMission?.mission) return
      this.$store.myActions.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT({
        itemId: this.currentDetailMission.mission.gliId,
        newProperties: {
          mod_settings: {
            SingleWayPoint_target: {
              lat_target: parseFloat(coord[1].toFixed(5)),
              lon_target: parseFloat(coord[0].toFixed(5)),
            },
          },
        },
      })
    },
    onDrawstart(evt) {
      //on vide le tableau des anciens dessins
      this.measuresFeatures = []
      this.currentMeasureFeature = evt.feature
      let tooltipCoord = evt.coordinate
      this.measureText = null
      this.measureListener = this.currentMeasureFeature.getGeometry().on('change', evt => {
        let geom = evt.target
        let output
        if (geom instanceof Polygon) {
          this.measureText = this.$options.filters.formatArea(sphere.getArea(geom))
          const coord = proj.transform(
            geom.getInteriorPoint().getCoordinates(),
            proj.get('EPSG:3857'),
            proj.get('EPSG:4326'),
          )
          this.measureCoord = [coord[0], coord[1]]
        } else if (geom instanceof LineString) {
          if (this.measureTool == MeasureToolType.BEARING) {
            this.measureText = this.$options.filters.formatBearing(
              bearing(
                proj.transform(geom.getFirstCoordinate(), proj.get('EPSG:3857'), proj.get('EPSG:4326')),
                proj.transform(geom.getLastCoordinate(), proj.get('EPSG:3857'), proj.get('EPSG:4326')),
              ),
            )
            this.measureCoord = proj.transform(geom.getFirstCoordinate(), proj.get('EPSG:3857'), proj.get('EPSG:4326'))
          } else {
            this.measureText = this.$options.filters.formatDistance(sphere.getLength(geom))
            this.measureCoord = proj.transform(geom.getLastCoordinate(), proj.get('EPSG:3857'), proj.get('EPSG:4326'))
          }
        } else if (geom instanceof Circle) {
          //console.log(evt)
          //this.measureText = this.formatSphere(geom )
          //this.measureText = "Radius: "+this.$options.filters.formatDistance(sphere.getDistance(proj.transform([evt.target.flatCoordinates[0],evt.target.flatCoordinates[1]],proj.get('EPSG:3857'),proj.get('EPSG:4326')),proj.transform([evt.target.flatCoordinates[2],evt.target.flatCoordinates[3]],proj.get('EPSG:3857'),proj.get('EPSG:4326'))))
          this.measureText =
            'Radius: ' +
            this.$options.filters.formatDistance(
              sphere.getDistance(
                proj.transform(geom.getCenter(), proj.get('EPSG:3857'), proj.get('EPSG:4326')),
                this.curCoord,
              ),
            )
          this.measureCoord = proj.transform(geom.getCenter(), proj.get('EPSG:3857'), proj.get('EPSG:4326'))
        }
      })
    },
    onDrawend(evt) {
      unByKey(this.measureListener)
      if (this.measureTool == MeasureToolType.PROFILE_DEPTH) {
        this.$store.myActions.UI_SHOW_DEPTH_PROFILE_DIALOG(evt.feature)
      }
      /*else if(this.measureTool == MeasureToolType.CIRCLE){
          this.measureText =    "Radius: "+this.$options.filters.formatDistance(sphere.getDistance(proj.transform(evt.target.sketchCoords_[0],proj.get('EPSG:3857'),proj.get('EPSG:4326')),proj.transform(evt.target.sketchCoords_[1],proj.get('EPSG:3857'),proj.get('EPSG:4326'))))

        }*/
    },
    onMissionPlanDrawend(evt) {
      //dans tous les cas ajout du wpt
      const newCoord = proj.transform(
        evt.feature.getGeometry().getCoordinates(),
        proj.get('EPSG:3857'),
        proj.get('EPSG:4326'),
      )
      const newWpt = { wpt_label: '', wpt_lon: newCoord[0], wpt_lat: newCoord[1], id: this.nextEditWptsId() }
      this.editMissionPlanState.missionPlan.wpts.push(newWpt)
      //si drawmode step ajout aussi du step
      if (this.editMissionPlanState.drawMode == 'step') {
        this.addNewStep(newWpt)
      }

      //@ts-ignore supprime le point ajouté
      this.$nextTick(() => {
        if (this.$refs.newWayPointIdent) this.$refs.newWayPointIdent.clearFeatures()
      })
    },
    onMissionPlanModifyend(evt) {
      if (this.editMissionPlanState.currentEditWpt.id > 0) {
        //@ts-ignore
        const newWayPt = this.$refs.modWaypoint.getCoordinates()
        this.editMissionPlanState.currentEditWpt.wpt_lon = parseFloat(newWayPt[0].toFixed(5))
        this.editMissionPlanState.currentEditWpt.wpt_lat = parseFloat(newWayPt[1].toFixed(5))
      }
    },
    nextEditWptsId() {
      return this.editMissionPlanState.missionPlan.wpts.length > 0
        ? Math.max(...this.editMissionPlanState.missionPlan.wpts.map(i => i.id)) + 1
        : 1
    },
    onModifyend(evt) {
      const newWayPt = this.$refs.wayPoint.getCoordinates()
      if (this.maptype == 'picker') {
        this.$emit('input', [newWayPt[1], newWayPt[0]])
      }
      // else if(this.maptype == 'simulation') {
      //   this.$store.myGetters.modifiedAdmMissionGlobal.config.wpt_init = [newWayPt[1],newWayPt[0]]
      // }
      else {
        this.$store.myActions.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT({
          itemId: this.currentDetailMission.mission.gliId,
          newProperties: {
            mod_settings: {
              SingleWayPoint_target: {
                lat_target: parseFloat(newWayPt[1].toFixed(5)),
                lon_target: parseFloat(newWayPt[0].toFixed(5)),
              },
            },
          },
        })
      }
    },
    onQuickControlModifyend(evt) {
      const newPt = this.$refs.quickControlWayPoint.getCoordinates()
      const misId = this.currentDetailMission.mission.misId
      this.updateQuickControlEasyWaypointTarget(misId, parseFloat(newPt[1].toFixed(5)), parseFloat(newPt[0].toFixed(5)))
    },
    //formatSphere(center,extpoint) {
    formatSphere(circle) {
      //const center = circle.getCenter();
      //const pointOnPerimeter = [center[0], center[1] + circle.getRadius()]
      //const radius = sphere.getDistance(proj.transform(center,proj.get('EPSG:3857'),proj.get('EPSG:4326')),proj.transform(pointOnPerimeter,proj.get('EPSG:3857'),proj.get('EPSG:4326')))

      //   /*const length = this.$options.filters.formatDistance(2 * Math.PI * radius)
      //   const area = this.$options.filters.formatArea(Math.PI * radius * radius)*/

      //   console.log(circle)
      //   console.log(circle.getCenter(),circle.extent_[0],circle.extent_[1],circle.extent_[2],circle.extent_[3])
      //   //console.log( this.$options.filters.formatDistance(new LineString([[circle.extent_[0],circle.extent_[1]],[circle.extent_[0],circle.extent_[3]]])))
      //  // console.log(sphere.getDistance(proj.transform(circle.extent_[0],proj.get('EPSG:3857'),proj.get('EPSG:4326')),proj.transform(circle.extent_[2],proj.get('EPSG:3857'),proj.get('EPSG:4326'))));
      //   //console.log(sphere.getLength(circle.extent_))
      const radius =
        sphere.getDistance(
          proj.transform([circle.extent_[0], circle.extent_[1]], proj.get('EPSG:3857'), proj.get('EPSG:4326')),
          proj.transform([circle.extent_[0], circle.extent_[3]], proj.get('EPSG:3857'), proj.get('EPSG:4326')),
        ) / 2.0

      //const radius = this.$options.filters.formatDistance(sphere.getDistance(proj.transform(center,proj.get('EPSG:3857'),proj.get('EPSG:4326')),proj.transform(extpoint,proj.get('EPSG:3857'),proj.get('EPSG:4326'))))

      return 'Radius: ' + this.$options.filters.formatDistance(radius) //+"<br/>Perimètre: " + length + "<br/>Surface: " + area;
    },
    updateGraticuleFormat() {
      /*if(this.coordFormatFilter == 'formatEPSG4326ToHDMS') {
          this.graticule.latLabelFormatter_ = this.defaultGraticuleLatLabelFormatter_
          this.graticule.lonLabelFormatter_ = this.defaultGraticuleLonLabelFormatter_
        }
        else {
          this.graticule.latLabelFormatter_ = (lat) =>  { return this.$options.filters[this.coordFormatFilter]([1,lat],true) }
          this.graticule.lonLabelFormatter_ = (lng) =>  { return this.$options.filters[this.coordFormatFilter]([lng,1],false) }
        } */

      this.graticule.latLabelFormatter_ = lat => {
        return this.$options.filters[this.coordFormatFilter]([1, lat], true)
      }
      this.graticule.lonLabelFormatter_ = lng => {
        return this.$options.filters[this.coordFormatFilter]([lng, 1], false)
      }
      this.redrawMap()
    },
    mapStylesFunction() {
      return feature => {
        const missionid = feature.get('missionid')
        const type = feature.get('type')
        if (missionid) {
          //couleur des simulations
          if (missionid <= -8) return mapStyles.orange(feature)
          if (missionid <= -7) return mapStyles.black(feature)
          if (missionid <= -6) return mapStyles.yellow(feature)
          if (missionid <= -5) return mapStyles.red(feature)
          if (missionid <= -4) return mapStyles.purple(feature)
          if (missionid <= -3) return mapStyles.green(feature)
          if (missionid <= -2) return mapStyles.blue(feature)
          if (missionid <= -1) return mapStyles.orange(feature)
          const missionMapStyle = this.missionAbsState(missionid).mapStyles
          if (missionMapStyle && missionMapStyle.fct) return missionMapStyle.fct(feature)
        }
        if (this.maptype == 'fleet') {
          const fleetMapStyle = this.currentFleetMapState.mapStyles
          if (fleetMapStyle && fleetMapStyle.fct) return fleetMapStyle.fct(feature)
        }
        if (this.mapstate.defaultMapStyles.fct) return this.mapstate.defaultMapStyles.fct(feature)
        //les simulations sont orange par default
        if (this.maptype == 'simulation') return mapStyles.orange(feature)
        return this.mapstate.baseMapLayer.id == 'OSM' ? mapStyles.black(feature) : mapStyles.white(feature)
      }
    },
    onMapMounted() {
      this.mapReady = false
      this.moveListener = this.$refs.map.$map.on('moveend', evt => {
        this.$store.myActions.UI_POS_MAP({
          center: proj.transform(this.$refs.view.$view.getCenter(), proj.get('EPSG:3857'), proj.get('EPSG:4326')),
          zoom: this.$refs.view.$view.getZoom(),
          uiid: this.uiid,
        })
      })

      this.mouseControl = new MousePosition({
        coordinateFormat: this.$options.filters[this.coordFormatFilter],
        projection: 'EPSG:4326',
      })
      this.$refs.map.$map.getControls().extend([new ScaleLine(), this.mouseControl])
      /*this.$refs.map.$map.getInteractions().forEach((interaction) => {
          if (interaction instanceof MouseWheelZoom) {
            this.$refs.map.$map.removeInteraction(interaction)
            //interaction.setActive(false);
          }
        })

       this.wheelListener =  this.$refs.map.$map.on('wheel', (e) => {
          e.preventDefault();
          var now = new Date();
          if(this.lastScrollZoom === null || now > this.lastScrollZoom ) {
            zoomByDelta(this.$refs.view.$view,e.originalEvent.deltaY < 0?1:-1,e.coordinate,this.scrollDelta)
            this.lastScrollZoom = now.setMilliseconds(now.getMilliseconds() + this.scrollDelta)
          }
        })*/
      this.graticule.setMap(this.showGraticule ? this.$refs.map.$map : null)
      this.updateGraticuleFormat()
      if (!this.isGlobal) {
        if (this.maptype == 'picker') {
          this.zoom = this.mapstate.mapZoom
          this.center = this.gliderModifiedWayPointCoord
        } else if (this.mapstate.mapCenter[0] == 0) {
          setTimeout(() => this.goToBestFit(this.missions), 500)
        } else {
          this.zoom = this.mapstate.mapZoom
          this.center = this.mapstate.mapCenter
        }
      } else {
        this.zoom = this.mapstate.mapZoom
        this.center = this.mapstate.mapCenter
      }

      this.layers.forEach(layer => {
        this.$store.myActions.MAPLAYER_ENSURE_DETAIL(layer.id)
      })

      this.$nextTick(() => {
        this.mapReady = true
        if (!this.isGlobal) this.onMissionPlanChanged()
        this.isMissionPlanEditable = this.isMissionPlanEditableToWatch
        this.isSmartCoverageEditable = this.isSmartCoverageEditableToWatch
      })

      /*setTimeout(() => {
          const ol3d =  new OLCesium({map: this.$refs.map.$map})
          ol3d.setEnabled(true);
        },2000)*/
    },
    updateSize() {
      if (!this.$refs.map) this.$nextTick(this.updateSize)
      else
        setTimeout(() => {
          if (this.$refs.map) {
            this.$refs.map.updateSize()
            this.redrawMap()
          }
        }, 200)
    },
    redrawMap() {
      //Twick force le refresh de la carte
      this.zoom += 1
      this.zoom -= 1
    },
    goToBestFit(missions, duration = 700) {
      if (missions.length) {
        let allExt = extent.createEmpty()
        missions.forEach(mission => {
          if (mission?._extent) extent.extend(allExt, mission._extent)
        })
        const ext = proj.transformExtent(allExt, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        this.fitToExtent(ext, duration)
      } else if (this.allCovWayPoint.length) {
        let allExt = extent.createEmpty()
        this.allCovWayPoint.forEach(wpt => {
          extent.extendCoordinate(allExt, wpt.position)
        })
        const ext = proj.transformExtent(allExt, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        //console.log(ext)
        this.fitToExtent(ext, duration)
      } else if (this.editMissionPlanState?.missionPlan?.wpts?.length) {
        const ext = extent.boundingExtent(
          this.editMissionPlanState?.missionPlan?.wpts
            .filter(wpt => wpt.wpt_lon != null && wpt.wpt_lat != null)
            .map(wpt => [wpt.wpt_lon, wpt.wpt_lat]),
        )
        const ext3857 = proj.transformExtent(ext, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        this.fitToExtent(ext3857)
      } else if (this.visibleMission.length) {
        let allExt = extent.createEmpty()
        this.visibleMission.forEach(mission => {
          if (mission?._extent) extent.extend(allExt, mission._extent)
        })
        const ext = proj.transformExtent(allExt, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        this.fitToExtent(ext, duration)
      } else if (this.isFleetDetailMap && this.coverageGridPoints?.length) {
        const ext = extent.boundingExtent(this.coverageGridPoints)
        const ext3857 = proj.transformExtent(ext, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        this.fitToExtent(ext3857)
      }
    },
    fitToExtent(ext, duration = 700) {
      if (ext[0] != -Infinity) {
        if (ext[0] == ext[2] || ext[1] == ext[3]) {
          if (extent.getCenter(ext))
            this.goTo(proj.transform(extent.getCenter(ext), proj.get('EPSG:3857'), proj.get('EPSG:4326')), 6, duration)
        } else {
          this.$refs.view.$view.fit(ext, { duration })
        }
      }
    },
    getBestZoom(mission) {
      /*const yoextent = extent.boundingExtent(mission.yoArray.map(y => [y.yoGpsLon,y.yoGpsLat]))
        const ext = proj.transformExtent(yoextent, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
        const resolution = this.$refs.view.$view.getResolutionForExtent(ext)
        const bestZoom = this.$refs.view.$view.getZoomForResolution(resolution)
        return bestZoom - 2*/
      return 6
    },
    canShowMission(mission) {
      //return true
      if (!this.$refs.view) return false
      //en mode non global on n'affiche que la mission current
      //if(!this.isGlobal && mission.misId != this.currentDetailMission.mission.misId) return false
      if (this.zoom < 4) return true

      const mapextent = proj.transformExtent(
        this.$refs.view.$view.calculateExtent(),
        proj.get('EPSG:3857'),
        proj.get('EPSG:4326'),
      )
      /*if(!mission._extent){
          mission._extent = extent.boundingExtent(mission.yoArray.map(y => [y.yoGpsLon, y.yoGpsLat]))
        }*/

      if (mapextent[0] >= -180 && mapextent[2] <= 180) {
        return extent.intersects(mapextent, mission._extent)
      } else {
        //on est a cheval sur deux rendu de la terre on fait en sorte de tester les deux zone
        const minLng = ((mapextent[0] + 180.0) % 360.0) - 180.0
        const maxLng = ((mapextent[2] + 180.0) % 360.0) - 180.0
        return (
          extent.intersects([-180.0, mapextent[1], maxLng, mapextent[3]], mission._extent) ||
          extent.intersects([minLng, mapextent[1], 180.0, mapextent[3]], mission._extent)
        )
      }
    },
    isInTimeLineRange(missionId, index) {
      const mRange = this.missionState(missionId).rangeTimelineIndex
      if (mRange[0] != -1) {
        return mRange[0] <= index && mRange[1] >= index
      }
      return true
    },
    rangeLength(mission) {
      const mRange = this.missionState(mission.misId).rangeTimelineIndex
      if (mRange[0] != -1) {
        return mRange[1] - mRange[0]
      }
      return mission.yoArray.length
    },
    getCourantYoCoord(mission, index) {
      let yo = null
      let offset = 1
      while (index - offset >= 0 && (yo = mission.yoArray[index - offset]).isUnderWater) {
        offset++
      }
      if (yo && !yo.isUnderWater) {
        const curYo = this.mapstate.showDrift
          ? mission.yoArray[index].driftArray[0] || mission.yoArray[index]
          : mission.yoArray[index]
        const prevYo = yo

        if (prevYo.yoGpsLon && curYo.yoGpsLon && prevYo.yoGpsLat && curYo.yoGpsLat)
          return [(prevYo.yoGpsLon + curYo.yoGpsLon) / 2.0, (prevYo.yoGpsLat + curYo.yoGpsLat) / 2.0]
      }
      return null
    },
    getMeanCourant(mission, yoCycle) {
      if (this.maptype == 'simulation') {
        const yo = mission?.yoArray?.find(y => y?.yosCycle == yoCycle)
        if (yo) {
          return {
            cr: yo.cr,
            cf: yo.cf,
          }
        }
      } else {
        const idxHeading = mission?.dataNmea['seadrk']?.columns?.findIndex(c => c.dbName == 'SDK_DATA_HEADING_CUR')
        const idxSpeed = mission?.dataNmea['seadrk']?.columns?.findIndex(c => c.dbName == 'SDK_DATA_SPD_CUR')
        if (
          idxHeading &&
          idxSpeed &&
          mission.dataNmea['seadrk']?.dataSet[yoCycle] &&
          mission.dataNmea['seadrk']?.dataSet[yoCycle]
        ) {
          return {
            cr: mission.dataNmea['seadrk']?.dataSet[yoCycle][idxHeading],
            cf: mission.dataNmea['seadrk']?.dataSet[yoCycle][idxSpeed],
          }
        }
      }
      return null
    },
    hasMeanCourant(mission, yoCycle) {
      const meanCourant = this.getMeanCourant(mission, yoCycle)
      return meanCourant && (meanCourant.cr || meanCourant.cr == 0) && meanCourant.cf
    },
    getCurrentYo(mission) {
      let mIndex = -1
      if (mission.covId) {
        const idx = mission.misIdx
        const covItMissionUiid = buildCoverageIterationMissionUiStateId(
          buildCoverageIterationUiStateId(mission.covId, 'detail'),
          `GLIDER${idx + 1}`,
        )
        const covIterationMissionState = this.$store.myGetters.coverageIterationMissionUiStateByUiid(covItMissionUiid)
        mIndex = covIterationMissionState.timelineIndex
      } else {
        mIndex = this.missionState(mission.misId).timelineIndex
      }
      const index = mIndex != -1 ? mIndex : mission.yoArray.length - 1
      return mission.yoArray[index]
    },
    getCurrentCoord(mission) {
      if (!mission) return [0, 0]
      const yo = this.getCurrentYo(mission)
      return [yo.yoGpsLon, yo.yoGpsLat]
    },
    getLastYoCoord(mission) {
      const yo = mission.yoArray[mission.yoArray.length - 1]
      if (yo?.yoGpsLon && yo?.yoGpsLat) {
        return [yo.yoGpsLon, yo.yoGpsLat]
      }
      return null
    },
    displayProfilNav(prf, hideLabel = false) {
      if (!prf) return ''
      return `${
        hideLabel ? '' : prf.prf_label && prf.prf_label.length > 0 ? prf.prf_label : `Profil ${prf.id}`
      }  ( bd:${prf.bd}, bu:${prf.bu}, pd:${prf.pd}, pu:${prf.pu}, sr:${prf.sr}, zb:${prf.zb}, zt:${prf.zt}, alt:${
        prf.alt
      })`
    },
    displayProfilSci(prf, hideLabel = false) {
      if (!prf) return ''
      //@ts-ignore
      const sensors =
        Object.keys(prf.sensors ?? [])
          .map(key => {
            const label = this.sensorById[parseInt(key)]?.snr_label
            const config = prf.sensors[parseInt(key)] ?? [1, '111', 1]
            //@ts-ignore
            const sensorPhase = (config?.at(1) ?? '111').toString().padStart(3, '0')
            return {
              label,
              //@ts-ignore
              enable: (config?.at(0) ?? 1) != 0,
              //@ts-ignore
              descEnable: sensorPhase?.at(0) != '0',
              //@ts-ignore
              otherEnable: sensorPhase?.at(1) != '0',
              //@ts-ignore
              ascEnable: sensorPhase?.at(2) != '0',
              //@ts-ignore
              periode: config?.at(2) ?? 1,
            }
          })
          .filter(it => it.enable)
          .map(
            it =>
              `${it?.label} ${it.descEnable ? '↓' : ''}${it.otherEnable ? '⥴' : ''}${it.ascEnable ? '↑' : ''} ${
                it.periode
              }s`,
          )
          .join(', ') ?? ''
      return `${hideLabel ? '' : prf.prf_label && prf.prf_label.length > 0 ? prf.prf_label : `Profil sci ${prf.id}`}  ${
        sensors.length > 0 ? `(${sensors})` : ''
      }`
    },
    gliderWayPointCoord(mission) {
      const runtime = mission?.gliderRuntime
      if (runtime && runtime.targetPilot && runtime.targetPilot.length > 0) {
        return [runtime.targetLon, runtime.targetLat]
        /*const originalSingleWayPointConfig = this.$store.myGetters.originalSingleWayPointConfigs[mission.gliId]
          if(originalSingleWayPointConfig) {
            return [originalSingleWayPointConfig.mod_settings.SingleWayPoint_target.lon_target,originalSingleWayPointConfig.mod_settings.SingleWayPoint_target.lat_target]
          }*/
      }
    },
    hasCurrentCoord(mission) {
      const yo = this.getCurrentYo(mission)
      return yo && yo.yoGpsLon && yo.yoGpsLat
    },
    hasGliderWayPointCoord(mission) {
      const yo = this.gliderWayPointCoord(mission)
      return yo && yo.length == 2 && yo[0] >= -180 && yo[0] <= 180 && yo[1] >= -90 && yo[1] <= 90
    },
    getPath(mission) {
      //return mission.yoArray.filter(y => y.yoGpsLat!= null && y.yoGpsLon != null).map(y => {return [y.yoGpsLon,y.yoGpsLat]})
      let index = 0
      return mission.yoArray.reduce((acc, y) => {
        if (
          this.mapstate.showDrift &&
          y.driftArray &&
          y.driftArray.length > 0 &&
          this.isInTimeLineRange(mission.misId, index)
        ) {
          y.driftArray.forEach(p => {
            if (p.yoGpsLon && p.yoGpsLat) acc.push([p.yoGpsLon, p.yoGpsLat])
          })
        } else if (y.yoGpsLat && y.yoGpsLon) {
          acc.push([y.yoGpsLon, y.yoGpsLat])
        }
        index++
        return acc
      }, [])
    },
    onKeyRight() {
      this.infosMissionIds.forEach(misId => {
        const missionState = this.missionState(misId)
        const mission = this.$store.myGetters.missionsById[misId]
        const index = missionState.timelineIndex != -1 ? missionState.timelineIndex : mission.yoArray.length - 1
        if (index < mission.yoArray.length - 1) {
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({
            index: index + 1,
            uiid: buildMissionUIStateId(misId, this.mapstate.typeUiid),
          })
        }
      })
    },
    onKeyLeft() {
      this.infosMissionIds.forEach(misId => {
        const missionState = this.missionState(misId)
        const mission = this.$store.myGetters.missionsById[misId]
        const index = missionState.timelineIndex != -1 ? missionState.timelineIndex : mission.yoArray.length - 1
        if (index > 0) {
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({
            index: index - 1,
            uiid: buildMissionUIStateId(misId, this.mapstate.typeUiid),
          })
        }
      })
    },
    onSingleclick({ pixel }) {
      if (this.$refs.map && this.measureTool == MeasureToolType.NONE) {
        let find = false
        let feature = this.$refs.map.forEachFeatureAtPixel(
          pixel,
          (feature, layer) => {
            if (!find) {
              const type = feature.get('type')
              if (type == 'mission') {
                find = true
                this.$store.myActions.UI_SELECT_MISSION_MAP({ id: feature.get('mission').misId, uiid: this.uiid })
              } else if (type == 'yo') {
                find = true
                const index = feature.get('index')
                const missionId = feature.get('missionid')
                this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({
                  index,
                  uiid: buildMissionUIStateId(missionId, this.mapstate.typeUiid),
                })
              }
            }
          },
          {
            hitTolerance: 5,
          },
        )
      }
    },
    onPointerMove({ pixel, coordinate }) {
      if (this.$refs.map && this.measureTool == MeasureToolType.NONE) {
        let resetStep = true
        let resetYo = true
        let resetCourant = true
        let resetMission = true
        let resetMissionStep = true
        this.cursorHover = false
        this.cursorHelp = false
        let find = false
        this.$refs.map.forEachFeatureAtPixel(
          pixel,
          (feature, layer) => {
            if (!find) {
              find = true
              const type = feature.get('type')
              if (type == 'mission' || type == 'lastyo') {
                this.hover_misison = feature.get('mission')
                this.cursorHover = true
                resetMission = false
              } else if (type == 'yo') {
                this.hover_yo = feature.get('yo')
                this.yo_type = 'yo'
                this.cursorHelp = true
                resetYo = false
              } else if (type == 'currentStep' || type == 'histoStep') {
                this.hover_step = feature.get('step')
                this.yo_type = 'step'
                this.cursorHelp = true
                resetStep = false
              } else if (type == 'cap') {
                //this.hover_yo = feature.get('yo')
                //this.yo_type = 'cap'
              } else if (type == 'courant') {
                this.hover_courant = {
                  pos: this.$refs.map.getCoordinateFromPixel(pixel),
                  mean: feature.get('courant'),
                }
                this.yo_type = 'courant'
                resetCourant = false
              } else if (type == 'step' || type == 'hoverStep' || type == 'currentMpStep' || type == 'backStep') {
                const missionid = feature.get('missionid')
                if (!missionid && this.maptype == 'simulation') {
                  this.editMissionPlanState.hoverStepId = feature.get('step_id')
                  const hoverStep = this.editStepsById[feature.get('step_id')]
                  this.hoverProfil = this.displayProfilNav(this.editPrf_navById[hoverStep.prfNav_id])
                  if (!isAloDbMissionGlobalFormation(this.$store.myGetters.modifiedAdmMissionGlobal)) {
                    this.hoverProfilSci = this.displayProfilSci(this.editPrf_sciById[hoverStep.prfSci_id])
                  }
                } else if (!missionid && this.maptype == 'fleet') {
                  this.editMissionPlanState.hoverStepId = feature.get('step_id')
                  const hoverStep = this.editStepsById[feature.get('step_id')]
                  this.hoverProfil = this.displayProfilNav(this.editPrf_navById[hoverStep.prfNav_id])
                  // if(!isAloDbMissionGlobalFormation(this.$store.myGetters.modifiedAdmMissionGlobal)) {
                  //   this.hoverProfilSci = this.displayProfilSci(this.editPrf_sciById[hoverStep.prfSci_id])
                  // }
                } else {
                  this.missionPlanStateByMisid[missionid].hoverStepId = feature.get('step_id')
                  const hoverStep = this.stepsById[missionid][feature.get('step_id')]
                  this.hoverProfil = this.displayProfilNav(this.prf_navById[missionid][hoverStep.prfNav_id])
                  this.hoverProfilSci = this.displayProfilSci(this.prf_sciById[missionid][hoverStep.prfSci_id])
                }
                resetMissionStep = false
              }
            }
          },
          {
            hitTolerance: 10,
          },
        )
        if (resetMission) this.hover_misison = null
        if (resetYo) this.hover_yo = null
        if (resetStep) this.hover_step = null
        if (resetCourant) this.hover_courant = null
        if (resetMissionStep) {
          this.missionPlanMission.forEach(m => {
            if (this.missionPlanStateByMisid[m.misId]) this.missionPlanStateByMisid[m.misId].hoverStepId = -1
          })
          if (this.isMissionPlanEditable) this.editMissionPlanState.hoverStepId = -1
          this.hoverProfil = ''
          this.hoverProfilSci = ''
        }
      } else {
        this.curCoord = coordinate
      }
    },
    kmlFactory() {
      return new KML()
    },
    custFeatures(layer) {
      return this.kmlFactory().readFeatures(layer.LAY_DATA, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      })
    },
    getUnitForMeters(center, value) {
      const center3857 = proj.transform(center, proj.get('EPSG:4326'), proj.get('EPSG:3857'))
      const pointOnPerimeter = [center3857[0], center3857[1] + 1]
      const radius = sphere.getDistance(
        proj.transform(center3857, proj.get('EPSG:3857'), proj.get('EPSG:4326')),
        proj.transform(pointOnPerimeter, proj.get('EPSG:3857'), proj.get('EPSG:4326')),
      )

      return value / radius
    },
    goTo(location, bestzoom = 0, duration = 700) {
      let zoom = this.$refs.view.$view.getZoom()
      let parts = 2
      let called = false

      function callback(complete) {
        --parts
        if (called) {
          return
        }
        if (parts === 0 || !complete) {
          called = true
        }
      }
      this.$refs.view.animate(
        {
          center: location,
          duration: duration,
        },
        callback,
      )
      if (bestzoom > 0) {
        this.$refs.view.animate(
          {
            zoom: bestzoom,
            duration: duration / 2,
          },
          callback,
        )
      }
    },
    //FONCTION COVERAGE
    nextEditCovWptsId() {
      return this.coverageWptList?.length ? Math.max(...this.coverageWptList.map(i => i.id)) + 1 : 1
    },
    onCoverageDrawend(evt) {
      //dans tous les cas ajout du wpt
      const newCoord = proj.transform(
        evt.feature.getGeometry().getCoordinates(),
        proj.get('EPSG:3857'),
        proj.get('EPSG:4326'),
      )
      const newWpt = {
        wpt_label: '',
        wpt_lon: parseFloat(newCoord[0].toFixed(5)),
        wpt_lat: parseFloat(newCoord[1].toFixed(5)),
        id: this.nextEditCovWptsId(),
      }
      this.coverageWptList.push(newWpt)

      //@ts-ignore supprime le point ajouté
      this.$nextTick(() => {
        if (this.$refs.newCovPointIdent) this.$refs.newCovPointIdent.clearFeatures()
      })
    },
    onDepRecoveryDrawEnd(evt) {
      const closestPoint = this.$refs.coverageGridPoints
        .getGeometry()
        .getClosestPoint(evt.feature.getGeometry().getCoordinates())
      //const closestPoint = proj.transform(this.$refs.coverageGridPoints.getGeometry().getClosestPoint(evt.feature.getGeometry().getCoordinates()), proj.get('EPSG:3857'),proj.get('EPSG:4326'))
      const closestIndex = this.$refs.coverageGridPoints
        .getGeometry()
        .getCoordinates()
        .findIndex(p => p[0] == closestPoint[0] && p[1] == closestPoint[1])
      if (closestIndex != -1) {
        //recuperagtion du point de la grille par son index
        const selectedId = this.$store.myGetters.modifiedAdmMissionGlobal?.resultGridJson?.wpts.at(closestIndex).id
        if (this.editCoverageState.drawMode == 'RECOVERY')
          this.$store.myGetters.modifiedAdmMissionGlobal.config.recovery_point = selectedId
        else this.$store.myGetters.modifiedAdmMissionGlobal.config.deployment_point = selectedId
      }
      this.editCoverageState.drawMode = ''
    },
    onModifyCoveragePointend(evt) {
      const newWayPt = this.$refs.covPoint.getCoordinates()
      this.editCoverageState.currentEditWpt.wpt_lat = parseFloat(newWayPt[1].toFixed(5))
      this.editCoverageState.currentEditWpt.wpt_lon = parseFloat(newWayPt[0].toFixed(5))
    },
    cancelCoveragePoint() {
      this.editCoverageState.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
      this.editCoverageState.hoverWptKey = ''
    },
    updateCoveragePoint() {
      const wpt = this.coverageWptsById[this.editCoverageState.currentEditWpt.id]
      if (wpt) {
        Object.keys(this.editCoverageState.currentEditWpt).forEach(key => {
          //@ts-ignore
          if (key == 'wpt_lat' || key == 'wpt_lon') wpt[key] = parseFloat(this.editCoverageState.currentEditWpt[key])
          //@ts-ignore
          else if (key != 'id') wpt[key] = this.editCoverageState.currentEditWpt[key]
        })
      }
      this.cancelCoveragePoint()
    },
    editCoveragePoint(pt) {
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      if (this.editCoverageState.drawMode != '') this.editCoverageState.drawMode = ''
      this.$nextTick(() => {
        //on memorise les infos si un ancien waypoint etait en edition
        this.updateCoveragePoint()
        //on edite le nouveau waypoint
        this.editCoverageState.editAreaId = pt.areaId
        this.editCoverageState.currentEditWpt = JSON.parse(JSON.stringify(pt.wpt))
      })
    },
    deleteCoveragePoint(pt) {
      this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteWaypointMessage').toString()).then(remove => {
        if (remove) {
          //supprime le waypoint
          this.editCoverageState.editAreaId = pt.areaId
          this.$nextTick(() => {
            this.coverageWptList.splice(
              this.coverageWptList.findIndex(it => it.id == pt.wpt.id),
              1,
            )
          })
        }
      })
    },
    onCoveragePointHover(pt) {
      this.editCoverageState.editAreaId = pt.areaId
      this.editCoverageState.hoverWptKey = pt.key
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tooltip-measure {
  position: relative;
  background: #ffffff;
  border-radius: 4px;
  color: #000000;
  padding: 4px 8px;
  opacity: 0.9;
  white-space: nowrap;
}

.tooltip-measure:before {
  border-top: 6px solid #ffffff;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: '';
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}

.ol-mouse-position {
  bottom: 44px;
  left: unset;
  top: unset;
  right: 8px;
  background: rgba(0, 60, 136, 0.6);
  display: inline-block;
  padding: 0px 4px;
  color: #fff;
  font-weight: normal;
  border-radius: 2px;
  font-size: 12px;
}

.ol-scale-line {
  background: rgba(0, 60, 136, 0.6);
  top: unset;
  right: 8px;
  bottom: 17px;
  left: unset;
}

.ol-attribution {
  top: unset;
  right: unset;
  bottom: 8px;
  left: 8px;
}

.ol-zoom {
  top: 8px;
  right: 8px;
  bottom: unset;
  left: unset;
}

.hover {
  cursor: pointer;
}
.infos {
  cursor: help;
}
</style>
